import React, { Component, Fragment } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import {
  H4,
  H5,
  H6,
  Checkbox,
  normalizeBoolean,
  Radiobutton,
  IconButton,
  Collapsible,
  YearSelector,
  TextInput,
  PopOver,
  ConfirmationBox,
  ToggleSwitch,
  DropDown,
  Button
} from '../../../components/index.js';
import { strUpperCase } from '../../../util/index.js'
import SampleInfo from '../../../constants/json/radiobuttons/sampleInfo.json';
import MaterialTypes from '../../../constants/json/radiobuttons/materialTypes.json';
import individualTest from '../../../constants/json/checkboxes/individualTestPackages.json';
import Season from '../../../constants/json/checkboxes/season.json';
import repellent from '../../../constants/json/radiobuttons/repellent.json';
import foodOrMouth from '../../../constants/json/radiobuttons/foodOrMouth.json';
import eyeWear from '../../../constants/json/radiobuttons/eyeWear.json';
import mates from '../../../constants/json/radiobuttons/mates.json';
import embededProduct from '../../../constants/json/radiobuttons/embededProduct.json';
import sampleTypeInfo from '../../../constants/json/radiobuttons/sampleTypeInfo.json';
import ageGroup from '../../../constants/json/radiobuttons/ageGroup.json';
import sampleColor from '../../../constants/json/radiobuttons/sampleColor.json';
import certification from '../../../constants/json/radiobuttons/certification.json';
import skinContact from '../../../constants/json/radiobuttons/skinContact.json';
import recycledContent from '../../../constants/json/radiobuttons/recycledContent.json';
/*import recycledContentDesc from '../../../constants/json/radiobuttons/recycledContentDesc.json'; */
import {
  InitialProductTypeStore, currentProductTypeStore, onChangeProductType,
  onChangeScreeningInkVarient, getProductIdEdit, initialCertificationArry, recycledContentValue, productTypeChangeStatus
} from '../../../actions/trfActions';
import { propTypes } from 'react-widgets/lib/DateTimePicker.js';
import {
  fetchTp1Tp2Count
} from '../../../reducers/authReducer.js';
const titleStyles = {
  'font-weight': '700',
  'font-size': '16px',
  'line-height': '1.5'
};
const tp1tp2Msg ='Click on button to enable TP1, TP2 testing or Every 5th TRF will automatically generate a TP1, TP2 Default Test type and auto slide the button to yes';
function getSampleTypeInfo() {
  return sampleTypeInfo.map(productType => ({
    id: productType.id,
    value: productType.value,
    label: productType.label
  }));
}

function getAgeGroup() {
  return ageGroup.map(productType => ({
    id: productType.id,
    value: productType.value,
    label: productType.label
  }));
}

function getSampleColor() {
  return sampleColor.map(productType => ({
    id: productType.id,
    value: strUpperCase(productType.value),
    label: productType.label
  }));
}

export class TestingInfo extends Component {
  
  constructor(...props) {
    super(...props);
    this.state = {
      submitModal: false,
      message: '',
      resetMaterial: false,
      jewelryClearbtn: true,
      electronicClearbtn: true,
      certificationArry: [{ name: "", number: "", other: "" }],
      trfCountState:false,
      enableTP2Message:'',
      manuallySelectedTests: {
        testPackages: new Set(),
        testPackagesElectronic: new Set(),
        testPackagesPackaging: new Set(),
        testPackagesJewelry: new Set()
      }
    };
    this.resetTestingType = this.resetTestingType.bind(this);
    this.toysValidationMessage = this.toysValidationMessage.bind(this);
  }
  //Increase the trfCount by 1 and check the modulas of 5
  returnTp2Logic(trfCount) {
    const initialTrfCount = trfCount + 1;
    if (initialTrfCount > 0) {
      return initialTrfCount % 5 === 0;
    } else {
      return false;
    }
  }

  // Helper method to setup TP2 enable/disable logic
  setupTP2Logic() {
    const { change, testingInfoStates, returnTp1Tp2Type } = this.props;
    
    if (testingInfoStates.testingInfoStatus === "New") {
      const trfCount = returnTp1Tp2Type?.trfCount ?? testingInfoStates?.trfCount ?? 0;
      const tp2Status = this.returnTp2Logic(trfCount);
      if (tp2Status === false) {
      change('enableTP2', testingInfoStates.enableTP2);
      this.setState({ enableTP2Message: tp1tp2Msg });
      } else if (tp2Status === true) {
      change('enableTP2', true);
      this.setState({ enableTP2Message: tp1tp2Msg });
      }
    }
    
    if (testingInfoStates.testingInfoStatus === 'Edit') {
      const isFifth = Number.isInteger(testingInfoStates?.trfCount) && testingInfoStates.trfCount % 5 === 0;
      if(isFifth && testingInfoStates.enableTP2 === true){
        this.setState({ enableTP2Message: tp1tp2Msg })
      }else if (!isFifth && testingInfoStates.enableTP2 === true){
        this.setState({ enableTP2Message: tp1tp2Msg })
      }
      else if (!isFifth && testingInfoStates.enableTP2 === false){
        this.setState({ enableTP2Message: tp1tp2Msg })
      }
    }
    
    if (returnTp1Tp2Type && returnTp1Tp2Type.trfCount && testingInfoStates.testingInfoStatus === "Edit") {
      const tp2Status = this.returnTp2Logic(returnTp1Tp2Type.trfCount)
      if (tp2Status === false) {
        change('enableTP2', testingInfoStates.enableTP2)
      } else if (tp2Status === true) {
        change('enableTP2', true);
      }
    }
  }

  // Helper method to setup UI button states and certification
  setupUIStatesAndCertification() {
    const { testingInfoStates, initialCertificationArry, recycledContentValue } = this.props;
    
    if (testingInfoStates.electCategory === '') {
      this.setState({ electronicClearbtn: true })
    } else {
      this.setState({ electronicClearbtn: false })
    }
    if (testingInfoStates.jeweleryMaterialType === '') {
      this.setState({ jewelryClearbtn: true })
    } else {
      this.setState({ jewelryClearbtn: false })
    }
    if (testingInfoStates.certification !== '' && testingInfoStates.testingInfoStatus === 'Edit') {
      initialCertificationArry(testingInfoStates.certification)
      const { getInitialCertificationArry } = this.props
      const editCertificationArry = getInitialCertificationArry
      editCertificationArry.map(item => {
        if (item.name !== 'oeko' && item.name !== 'bluesign' && item.name !== 'eco') {
          item.other = 'sample'
        }
        return item
      })
    }
    if (testingInfoStates.certification && testingInfoStates.certification.length === 0 && testingInfoStates.testingInfoStatus === 'Edit') {
      initialCertificationArry([{ name: "", number: "", other: "" }])
    }
    if (testingInfoStates.recycle && testingInfoStates.recycle === true && testingInfoStates.testingInfoStatus === 'Edit') {
      recycledContentValue('Yes')
    }
  }

  // Helper method to handle product type changes
  handleProductTypeChangeOnMount() {
    const { change, testingInfoStates, productId, prevProductId, getProductTypeObj, InitialProductTypeStore, currentProductTypeStore, onChangeProductType, productTypeChangeStatus } = this.props;
    
    const getUpdatedProductType = getProductTypeObj
    if (getUpdatedProductType && getUpdatedProductType.isChanged === true) {
      InitialProductTypeStore(prevProductId)
      currentProductTypeStore(productId)
      const packagingTestPackageNullArry = new Array(individualTest[0].packaging.filter(data => data.isTestAvailable === true).length).fill(null);
      const testPackagesNullArry = new Array(individualTest[0].common.filter(data => data.isTestAvailable === true).length).fill(null);
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      const testPackagesJewelryNullArry = new Array(individualTest[0].jewelry.filter(data => data.isTestAvailable === true).length).fill(null);
      testingInfoStates.materialType && testingInfoStates.materialType.filter(element => element != null).forEach(id => {
        change(`subVariants`, null);
      });
      testingInfoStates.materialType && testingInfoStates.materialType.filter(element => element != null).forEach(id => {
        change(`variants${id}`, null);
      });
      
      // Clear all individual test variant selections (tp-variants{testId})
      const allTestCategories = ['common', 'packaging', 'jewelry', 'electronic'];
      allTestCategories.forEach(category => {
        const tests = individualTest[0][category] || [];
        tests.forEach(test => {
          if (test.variants && Array.isArray(test.variants)) {
            const variantFieldName = `tp-variants${test.id}`;
            change(variantFieldName, null);
          }
        });
      });
      
      change('materialType', [null])
      change('jeweleryMaterialType', '')
      change('electCategory', '')
      change('testPackages', testPackagesNullArry)
      change('testPackagesPackaging', packagingTestPackageNullArry)
      change('testPackagesJewelry', testPackagesJewelryNullArry)
      change('testPackagesElectronic', testPackagesElectronicNullArry)
      change('bisphenol593Manual', null)
      change('currentProductType', productId)
      change('InitialProductType', prevProductId)
      change('repellent', 'No')
      change('foodOrMouth', 'No')
      change('eyeWear', 'No')
      change('mates', 'No')
      change('testingType', 'PR')
      this.setState({
        manuallySelectedTests: {
          testPackages: new Set(),
          testPackagesElectronic: new Set(),
          testPackagesPackaging: new Set(),
          testPackagesJewelry: new Set()
        }
      });
      
      const storeProductTypeFalse = { isChanged: false, CurrentProductType: 0 }
      onChangeProductType(storeProductTypeFalse)
      // Reset the product type change status flag after processing
      productTypeChangeStatus(false)
    }
  }
   componentDidMount() {
    const { change, displaySubmitButtonTrf, displayClearButtonTrf, updateMaterialField, productId, 
      onChangeScreeningInkVarient, testingInfoStates, getProductIdEdit } = this.props;
    
    // Initialize previous material types for change detection
    this.prevMaterialTypes = testingInfoStates.materialType ? [...testingInfoStates.materialType] : [];
    
    // Setup TP2 logic
    this.setupTP2Logic();
    
    // Setup UI states and certification
    this.setupUIStatesAndCertification();
    
    // Edit form to get productId
    if (isNaN(productId) === false) {
      getProductIdEdit(productId)
    } else {
      getProductIdEdit('')
    }
    
    // Update material fields
    if (updateMaterialField.length > 0) {
      change('Material Product Information', updateMaterialField.length > 0 ? updateMaterialField.productInformation : '');
      change('supplierName', updateMaterialField.length > 0 ? updateMaterialField[1].supplierName : '');
      change('supLocName', updateMaterialField.length > 0 ? updateMaterialField[1].supLocName : '');
      change('testmaterialName', updateMaterialField.length > 0 ? updateMaterialField[0].materialName : '');
      change('testmaterialNumber', updateMaterialField.length > 0 ? updateMaterialField[0].materialNumber : '');
      change('refId', updateMaterialField.length > 0 ? updateMaterialField[0].refId : '');
    }
    
    const getVarientId = testingInfoStates.variants405
    onChangeScreeningInkVarient(getVarientId)
    
    if (typeof displaySubmitButtonTrf === 'function') {
      displaySubmitButtonTrf(false);
    }
    if (typeof displayClearButtonTrf === 'function') {
      displayClearButtonTrf(true);
    }
    
    // Handle product type changes
    this.handleProductTypeChangeOnMount();

    // In Edit mode, API can provide selected test IDs as a compact list.
    // Normalize to the indexed checkbox array shape used by Tab 2.
    this.normalizeEditCommonPackagesSelection();

    // Keep Yoga mat solvent requirement in sync for edit mode and initial form loads.
    this.syncYogaMateSolventSelection();

    // In TP1/default mode ensure polymer variant radios are not preselected.
    this.syncPolymerVariantForTP1();
  }

  normalizeEditCommonPackagesSelection = () => {
    const { testingInfoStates, change } = this.props;

    if (
      !testingInfoStates ||
      testingInfoStates.testingInfoStatus !== 'Edit' ||
      !Array.isArray(testingInfoStates.testPackages)
    ) {
      return;
    }

    const { common } = this.getProcessedArraysAndIndices();
    const currentTestPackages = testingInfoStates.testPackages;
    const selectedIds = [...new Set(currentTestPackages.filter(id => id !== null && id !== undefined))];
    const normalizedTestPackages = new Array(common.length).fill(null);

    selectedIds.forEach(testId => {
      const mappedIndex = common.findIndex(test => test.id === testId);
      if (mappedIndex !== -1) {
        normalizedTestPackages[mappedIndex] = testId;
      }
    });

    if (!isEqual(currentTestPackages, normalizedTestPackages)) {
      change('testPackages', normalizedTestPackages);
    }
  };

  handleEquipmentEyeWearChange = (prevTestingInfoStates) => {
    const { testingInfoStates, change, productId } = this.props;
    
    // When eyeWear changes, we need to remap the entire test package array
    // because the array structure changes (619 ↔ 530 swap)
    
    // Step 1: Collect all currently selected test IDs (not indices)
    const currentlySelectedTests = [];
    const previousTestPackages = Array.isArray(prevTestingInfoStates?.testPackages)
      ? prevTestingInfoStates.testPackages
      : [];
    previousTestPackages.forEach(testId => {
        if (testId !== null && testId !== undefined) {
          currentlySelectedTests.push(testId);
        }
      });
    
    // Step 2: Get the new array structure based on current eyeWear state
    const { common, indices } = this.getProcessedArraysAndIndices();
    
    // Step 3: Create a new array with the correct length, initialized with nulls
    const newTestPackages = new Array(common.length).fill(null);
    
    // Step 4: Update manual selections tracking for Phthalates conversion
    const { manuallySelectedTests } = this.state;
    const manualSelections = manuallySelectedTests.testPackages;
    const updatedManualSelections = new Set(manualSelections instanceof Set ? manualSelections : []);
    
    // Step 5: Map each selected test to its new correct index
    // IMPORTANT: Convert Phthalates 530 ↔ 619 based on CURRENT eyeWear state
    currentlySelectedTests.forEach(testId => {
      let mappedTestId = testId;
      
      // For Equipment products, handle Phthalates conversion based on eyewear state
      if (testingInfoStates.currentProductType === 202 || productId === 202) {
        if (testingInfoStates.eyeWear === 'Yes' && testId === 530) {
          // Convert Phthalates (530) to Phthalates (Eyewear) (619)
          mappedTestId = 619;
          // Update manual selections: remove 530, add 619 to preserve selection
          updatedManualSelections.delete(530);
          updatedManualSelections.add(619);
        } else if (testingInfoStates.eyeWear === 'No' && testId === 619) {
          // Convert Phthalates (Eyewear) (619) to Phthalates (530)
          mappedTestId = 530;
          // Update manual selections: remove 619, add 530 to preserve selection
          updatedManualSelections.delete(619);
          updatedManualSelections.add(530);
        }
      }
      
      const newIndex = common.findIndex(test => test.id === mappedTestId);
      if (newIndex !== -1) {
        newTestPackages[newIndex] = mappedTestId;
      }
    });
    
    // Step 6: Update the manual selections state
    // this.setState({
    //   manuallySelectedTests: {
    //     ...manuallySelectedTests,
    //     testPackages: updatedManualSelections
    //   }
    // });
    
    // Step 7: Handle PFAS tests based on repellent and foodOrMouth
    if (testingInfoStates.repellent === 'Yes' || testingInfoStates.foodOrMouth === 'Yes') {
      // Add test 597 if repellent OR foodOrMouth is Yes
      if (indices[597] !== -1) {
        newTestPackages[indices[597]] = 597;
      }
    }
    
    if (testingInfoStates.repellent === 'Yes') {
      // Add test 607 only if repellent is Yes
      if (indices[607] !== -1) {
        newTestPackages[indices[607]] = 607;
      }
    }
    
    // Step 6: Apply the remapped array
    change('testPackages', newTestPackages);
  }
  componentDidUpdate(prevProps) {
    const { testingInfoStates, productId } = this.props;
    const { testingInfoStates: prevTestingInfoStates } = prevProps;

    if (!testingInfoStates || !prevTestingInfoStates) {
      return;
    }

    if (
      prevTestingInfoStates.enableTP2 !== testingInfoStates.enableTP2 ||
      !isEqual(prevTestingInfoStates.materialType, testingInfoStates.materialType) ||
      prevTestingInfoStates.variants6017 !== testingInfoStates.variants6017
    ) {
      this.syncPolymerVariantForTP1();
    }

    if (
      testingInfoStates.testingInfoStatus === 'Edit' &&
      !isEqual(prevTestingInfoStates.testPackages, testingInfoStates.testPackages)
    ) {
      this.normalizeEditCommonPackagesSelection();
    }

    // Initialize manual selections from current state in Edit mode (once, when data first loads)
    if (
      testingInfoStates.testingInfoStatus === 'Edit' &&
      !this.hasInitializedManualSelectionsFromAPI &&
      Array.isArray(testingInfoStates.testPackages) &&
      testingInfoStates.testPackages.some(t => t != null)
    ) {
      this.hasInitializedManualSelectionsFromAPI = true;
     // this.initializeManualSelectionsFromCurrentState();
    }
    
    // Handle TP2 logic updates
    this.handleTP2LogicUpdate(prevProps);
     
    // CRITICAL: Check if product type changed - skip handlers below to avoid restoring cleared selections
    const hasProductTypeChange = prevProps.testingInfoStates.currentProductType !== testingInfoStates.currentProductType ||
                                  prevProps.productId !== productId;
    
    // Handle equipment/eyewear changes
     if (
          (prevProps.testingInfoStates.repellent !== testingInfoStates.repellent ||
          prevProps.testingInfoStates.foodOrMouth !== testingInfoStates.foodOrMouth ||
          prevProps.testingInfoStates.eyeWear !== testingInfoStates.eyeWear) &&
          (testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD') &&
          (testingInfoStates.currentProductType === 202 || productId === 202) &&
          !hasProductTypeChange
        ) {
          this.handleEquipmentEyeWearChange(prevProps.testingInfoStates);
        }

    if (
      prevProps.testingInfoStates.mates !== testingInfoStates.mates &&
      !hasProductTypeChange
    ) {
      this.syncYogaMateSolventSelection(prevProps.testingInfoStates.mates);
    }
    
    // Skip remaining handlers if product type changed (everything already cleared)
    
    // Handle repellent/foodOrMouth changes in edit mode for AP/FW/EQ/Accessories
    if (
      (prevProps.testingInfoStates.repellent !== testingInfoStates.repellent ||
       prevProps.testingInfoStates.foodOrMouth !== testingInfoStates.foodOrMouth) &&
      testingInfoStates.testingInfoStatus === 'Edit' &&
      [200, 201, 202, 206].includes(productId) &&
      !hasProductTypeChange
    ) {
      this.handlePFASTestsInEditMode();
    }
    
    // Handle repellent/foodOrMouth changes in Create mode - recalculate test packages
    if (
      (prevProps.testingInfoStates.repellent !== testingInfoStates.repellent ||
       prevProps.testingInfoStates.foodOrMouth !== testingInfoStates.foodOrMouth) &&
      testingInfoStates.testingInfoStatus !== 'Edit' &&
      !hasProductTypeChange
    ) {
      // Recalculate test packages to add/remove PFAS tests based on new repellent/foodOrMouth values
      // const combinedSelection = this.getSelectedMaterialsAndVariants();
      // if (combinedSelection.length > 0) {
      //   this.clearAndRecalculateTestPackages(combinedSelection);
      // }
    }

    // Handle material type and variant changes (skip if only product type changed)
    // if (!hasProductTypeChange) {
    //   this.handleMaterialTypeAndVariantChanges(prevProps);
    // }
    
    // Handle TP2 enable/disable changes in edit mode
    if (prevProps.testingInfoStates.enableTP2 !== testingInfoStates.enableTP2 && 
        testingInfoStates.testingInfoStatus === 'Edit' &&
        !hasProductTypeChange) {      // Get currently selected material types
      // const selectedMaterialTypes = Array.isArray(testingInfoStates.materialType) 
      //   ? testingInfoStates.materialType.filter(id => id != null)
      //   : [];
      
      // if (selectedMaterialTypes.length > 0) {
      //   // Recalculate test packages with the new TP2 state
      //   const combinedSelection = this.getSelectedMaterialsAndVariants();
      //   this.clearAndRecalculateTestPackages(combinedSelection, testingInfoStates.enableTP2);
      // }
    }

    // Update the instance variable with current material types for next update
    // Create a copy to avoid reference issues
    const currMaterialTypes = testingInfoStates.materialType || [];
    this.prevMaterialTypes = currMaterialTypes ? [...currMaterialTypes] : [];
    const { change } = this.props;

    // When material 400 is selected in Edit mode (or deselected), clear all its variant checkboxes.
    const prevHad400 = (prevProps.testingInfoStates.materialType || []).includes(400);
    const currHas400 = currMaterialTypes.includes(400);
    const isEditMode = testingInfoStates.testingInfoStatus === 'Edit';

    if ((prevHad400 && !currHas400) || (isEditMode && !prevHad400 && currHas400)) {
      const material400 = find(MaterialTypes, ['id', 400]);
      if (material400 && material400.variants) {
        material400.variants.forEach((variant, idx) => {
          change(`variants400[${idx}]`, null);
        });
      }
    }
  }
  
  // This method is no longer needed - manual selections are tracked naturally through user clicks

  // Helper method: Handle PFAS tests when repellent/foodOrMouth changes in edit mode
  handlePFASTestsInEditMode = () => {
    const { testingInfoStates, change, productId } = this.props;
    const { indices } = this.getProcessedArraysAndIndices();
    const { manuallySelectedTests } = this.state;
    
    if (!testingInfoStates.testPackages || !Array.isArray(testingInfoStates.testPackages)) {
      return;
    }
    
    // Only apply for AP/FW/EQ/Accessories
    if (![200, 201, 202, 206].includes(productId)) {
      return;
    }
    
    const testPackages = [...testingInfoStates.testPackages];
    const updatedManualSelections = new Set(manuallySelectedTests.testPackages);
    let modified = false;
    let manualSelectionsModified = false;
    
    // Handle PFAS test 597 (required for repellent OR foodOrMouth)
    if (testingInfoStates.repellent === 'Yes' || testingInfoStates.foodOrMouth === 'Yes') {
      if (indices[597] !== -1 && testPackages[indices[597]] !== 597) {
        testPackages[indices[597]] = 597;
        modified = true;
      }
      // Remove from manual selections since it's auto-selected
      if (updatedManualSelections.has(597)) {
        updatedManualSelections.delete(597);
        manualSelectionsModified = true;
      }
    } else {
      // Remove 597 if both repellent and foodOrMouth are 'No'
      if (indices[597] !== -1 && testPackages[indices[597]] === 597) {
        testPackages[indices[597]] = null;
        modified = true;
      }
      // Also remove from manual selections to prevent it from being restored
      if (updatedManualSelections.has(597)) {
        updatedManualSelections.delete(597);
        manualSelectionsModified = true;
      }
    }
    
    // Handle PFAS test 607 (required only for repellent)
    if (testingInfoStates.repellent === 'Yes') {
      if (indices[607] !== -1 && testPackages[indices[607]] !== 607) {
        testPackages[indices[607]] = 607;
        modified = true;
      }
      // Remove from manual selections since it's auto-selected
      if (updatedManualSelections.has(607)) {
        updatedManualSelections.delete(607);
        manualSelectionsModified = true;
      }
    } else {
      // Remove 607 if repellent is 'No'
      if (indices[607] !== -1 && testPackages[indices[607]] === 607) {
        testPackages[indices[607]] = null;
        modified = true;
      }
      // Also remove from manual selections to prevent it from being restored
      if (updatedManualSelections.has(607)) {
        updatedManualSelections.delete(607);
        manualSelectionsModified = true;
      }
    }
    
    // Update manual selections if modified
    if (manualSelectionsModified) {
      this.setState({
        manuallySelectedTests: {
          ...manuallySelectedTests,
          testPackages: updatedManualSelections
        }
      });
    }
    
    if (modified) {
      change('testPackages', testPackages);
    }
  };

  // Helper method to check if a test is part of currently selected material types' default selection
  // isTestInMaterialTypeSelection = (testId, materialTypeIds) => {
  //   const { testingInfoStates } = this.props;
    
  //   // Get TP1 and TP2 mappings
  //   const tp1Obj = Array.isArray(testPackageMatrixMapping) ? testPackageMatrixMapping.find(obj => obj.TP1) : undefined;
  //   const tp1MaterialTypes = tp1Obj && tp1Obj.TP1 && tp1Obj.TP1.materialType ? tp1Obj.TP1.materialType : [];
    
  //   const tp2Obj = Array.isArray(testPackageMatrixMapping) ? testPackageMatrixMapping.find(obj => obj.TP2) : undefined;
  //   const tp2MaterialTypes = tp2Obj && tp2Obj.TP2 && tp2Obj.TP2.materialType ? tp2Obj.TP2.materialType : [];
    
  //   // Check all selected material types
  //   for (const materialId of materialTypeIds) {
  //     // Check TP1
  //     const tp1Match = tp1MaterialTypes.find(item => item.id === materialId);
  //     if (tp1Match && Array.isArray(tp1Match.testPackage)) {
  //       const hasTest = tp1Match.testPackage.some(pkg => {
  //         const pkgId = typeof pkg === 'object' ? pkg.id : pkg;
  //         return Number(pkgId) === Number(testId);
  //       });
  //       if (hasTest) return true;
  //     }
      
  //     // Check TP2 if enabled
  //     if (testingInfoStates.enableTP2) {
  //       const tp2Match = tp2MaterialTypes.find(item => item.id === materialId);
  //       if (tp2Match && Array.isArray(tp2Match.testPackage)) {
  //         const hasTest = tp2Match.testPackage.some(pkg => {
  //           const pkgId = typeof pkg === 'object' ? pkg.id : pkg;
  //           return Number(pkgId) === Number(testId);
  //         });
  //         if (hasTest) return true;
  //       }
  //     }
  //   }
    
  //   return false;
  // };

  isYogaMateSolventRequired = () => {
    const { testingInfoStates, productId } = this.props;

    return (
      (testingInfoStates.currentProductType === 202 || productId === 202) &&
      testingInfoStates.mates === 'Yes'
    );
  };

  applyYogaMateSolventRequirement = (testPackages, prevMates = null) => {
    const nextTestPackages = Array.isArray(testPackages) ? [...testPackages] : [];
    const { common, indices } = this.getProcessedArraysAndIndices();
    const solventIndex = indices[599];
    const { manuallySelectedTests } = this.state;
    const hasManualSolventSelection = manuallySelectedTests.testPackages.has(599);

    while (nextTestPackages.length < common.length) {
      nextTestPackages.push(null);
    }

    if (solventIndex === -1) {
      return nextTestPackages;
    }

    if (this.isYogaMateSolventRequired()) {
      nextTestPackages[solventIndex] = 599;
    }

    if (prevMates === 'Yes' && !this.isYogaMateSolventRequired() && !hasManualSolventSelection) {
      nextTestPackages[solventIndex] = null;
    }

    // Do not auto-remove manual Solvent/Residual selection when Yoga mates is not required.
    return nextTestPackages;
  };

   syncYogaMateSolventSelection = (prevMates = null) => {
    const { change, testingInfoStates } = this.props;

    const nextTestPackages = this.applyYogaMateSolventRequirement(testingInfoStates.testPackages, prevMates);
    const currentTestPackages = Array.isArray(testingInfoStates.testPackages) ? testingInfoStates.testPackages : [];

    if (!isEqual(currentTestPackages, nextTestPackages)) {
      change('testPackages', nextTestPackages);
    }
  };

  syncPolymerVariantForTP1 = () => {
    const { change, testingInfoStates } = this.props;
    const selectedMaterialTypes = Array.isArray(testingInfoStates.materialType)
      ? testingInfoStates.materialType.filter(id => id != null)
      : [];
    const isTP1Only = testingInfoStates.enableTP2 !== true;
    const hasPolymerMaterial = selectedMaterialTypes.includes(6017);

    // In TP1/default mode, force default to No (6017).
    if (isTP1Only && hasPolymerMaterial && testingInfoStates.variants6017 !== 6017) {
      change('variants6017', 6017);
    }
  };

  // Helper method: Handle TP2 logic updates
  handleTP2LogicUpdate = (prevProps) => {
    const { returnTp1Tp2Type, testingInfoStates, change } = this.props;
    const {trfCountState} = this.state;
    
    if (prevProps.returnTp1Tp2Type !== returnTp1Tp2Type) {
      const previousTP2State = testingInfoStates.enableTP2;
      let newTP2State = previousTP2State;
      
      if (returnTp1Tp2Type && returnTp1Tp2Type.trfCount && testingInfoStates.testingInfoStatus === "New") {
        const tp2Status = this.returnTp2Logic(returnTp1Tp2Type.trfCount)
        newTP2State = tp2Status;
        if (tp2Status === false) { 
          change('enableTP2', false);
        } else if (tp2Status === true) {
          change('enableTP2', true);
        }
        this.setState({ enableTP2Message: tp1tp2Msg });
      } else if (returnTp1Tp2Type && typeof returnTp1Tp2Type.trfCount === 'number' && testingInfoStates.testingInfoStatus === "Edit") {
        const tp2Status = this.returnTp2Logic(returnTp1Tp2Type.trfCount)
        newTP2State = tp2Status;
        if (tp2Status === false) { 
          change('enableTP2', false);
        } else if (tp2Status === true) {
          change('enableTP2', true);
        }
        this.setState({ enableTP2Message: tp1tp2Msg });
        if(returnTp1Tp2Type && returnTp1Tp2Type.trfCount){
            change('trfCount', returnTp1Tp2Type.trfCount);
        }
      } else if (returnTp1Tp2Type && typeof returnTp1Tp2Type.trfCount === 'number' && testingInfoStates.testingInfoStatus === "Edit" && returnTp1Tp2Type === undefined && trfCountState === false) {
        change('enableTP2', testingInfoStates.enableTP2)
      }
      
      // If TP2 state changed due to location change, recalculate test packages
      if (previousTP2State !== newTP2State) {
        const selectedMaterialTypes = Array.isArray(testingInfoStates.materialType) 
          ? testingInfoStates.materialType.filter(id => id != null)
          : [];
        
        if (selectedMaterialTypes.length > 0) {
          // Recalculate test packages with the new TP2 state
          const combinedSelection = this.getSelectedMaterialsAndVariants();
          if (combinedSelection.length > 0) {
            this.clearAndRecalculateTestPackages(combinedSelection, newTP2State);
          }
        }
      }
    }
  };

  // Helper method: Handle all material type and variant changes
  // handleMaterialTypeAndVariantChanges = (prevProps) => {
  //   const { testingInfoStates, change, productId } = this.props;
    
  //   // Check for materialType, subVariants, or any variants{materialId} change
  //   let variantsChanged = false;
  //   // Use instance variable for previous material types to ensure proper change detection
  //   const prevMaterialTypes = this.prevMaterialTypes || [];
  //   const currMaterialTypes = testingInfoStates.materialType || [];
    
  //   // Initialize tp1MaterialTypes and tp2MaterialTypes here
  //   const tp1Obj = Array.isArray(testPackageMatrixMapping)
  //     ? testPackageMatrixMapping.find(obj => obj.TP1)
  //     : undefined;
  //   const tp1MaterialTypes = tp1Obj && tp1Obj.TP1 && tp1Obj.TP1.materialType
  //     ? tp1Obj.TP1.materialType
  //     : [];
  //   let tp2MaterialTypes = [];
  //   if (testingInfoStates.enableTP2 === true) {
  //     const tp2Obj = Array.isArray(testPackageMatrixMapping)
  //       ? testPackageMatrixMapping.find(obj => obj.TP2)
  //       : undefined;
  //     tp2MaterialTypes = tp2Obj && tp2Obj.TP2 && tp2Obj.TP2.materialType
  //       ? tp2Obj.TP2.materialType
  //       : [];
  //   }

  //   // Detect if material types were added
  //   const materialTypeAdded = currMaterialTypes.some(id => id != null && !prevMaterialTypes.includes(id));
    
  //   // Initialize removedSubVariants early so it can be used in variant change detection
  //   let removedSubVariants = [];
    
  //   // Check if any variants{materialId} array changed - improved detection
  //   const allMaterialIdsForVariantCheck = Array.from(new Set([
  //     ...prevMaterialTypes.filter(id => id != null),
  //     ...currMaterialTypes.filter(id => id != null)
  //   ]));
    
  //   allMaterialIdsForVariantCheck.forEach(materialId => {
  //     const prevVariants = prevProps.testingInfoStates[`variants${materialId}`];
  //     const currVariants = testingInfoStates[`variants${materialId}`];
  //     // Don't count it as variantsChanged if this is a newly added material type
  //     // and the variant field is just being initialized
  //     const isNewlyAddedMaterial = materialTypeAdded && !prevMaterialTypes.includes(materialId);
      
  //     if (!isEqual(prevVariants, currVariants)) {
  //       // If this is a newly added material and variants field is just being initialized to null/undefined,
  //       // don't mark as variantsChanged (check for both null and undefined)
  //       const bothNullish = (prevVariants == null) && (currVariants == null);
  //       if (!(isNewlyAddedMaterial && bothNullish) || (!isEqual(prevVariants, currVariants))) {
  //         variantsChanged = true;
  //       }
        
  //       // Special handling for material type 405 (Inks and Paints)
  //       // When variant changes from 4052 (Screenprint Inks) to something else, clear subVariants
  //       if (materialId === 405) {
  //         const prevVariant405 = prevVariants;
  //         const currVariant405 = currVariants;
          
  //         // If changed from 4052 to something else (4040 or null), clear subVariants
  //         if (prevVariant405 === 4052 && currVariant405 !== 4052) {
  //           // Get the old subVariant value before clearing
  //           const oldSubVariant = testingInfoStates.subVariants;
            
  //           // Clear subVariants
  //           change('subVariants', null);
            
  //           // Add old subVariant to removedSubVariants so its test packages get cleared
  //           if (oldSubVariant != null) {
  //             if (Array.isArray(oldSubVariant)) {
  //               removedSubVariants.push(...oldSubVariant.filter(v => v != null));
  //             } else {
  //               removedSubVariants.push(oldSubVariant);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });

  //   // Get removed variants - improved logic
  //   const removedVariants = [];
  //   const selectedVariants = [];
    
  //   // Check all material types that exist in either previous or current state
  //   const allMaterialIds = Array.from(new Set([
  //     ...prevMaterialTypes.filter(id => id != null),
  //     ...currMaterialTypes.filter(id => id != null)
  //   ]));
    
  //   allMaterialIds.forEach(materialId => {
  //     const prevVariants = prevProps.testingInfoStates[`variants${materialId}`];
  //     const currVariants = testingInfoStates[`variants${materialId}`];
      
  //     // Handle different variant data structures (array vs single value)
  //     const prevVariantsArray = Array.isArray(prevVariants) ? prevVariants : (prevVariants != null ? [prevVariants] : []);
  //     const currVariantsArray = Array.isArray(currVariants) ? currVariants : (currVariants != null ? [currVariants] : []);
      
  //     // Find removed variants (present in prev but not in curr)
  //     const removed = prevVariantsArray.filter(v => v != null && !currVariantsArray.includes(v));
  //     if (removed.length > 0) {
  //       removedVariants.push(...removed);
  //     }
      
  //     // Collect currently selected variants
  //     const currentSelected = currVariantsArray.filter(v => v != null);
  //     if (currentSelected.length > 0) {
  //       selectedVariants.push(...currentSelected);
  //     }
  //   });
  //   // Get removed subVariants (continue building the array initialized earlier)
  //   // Note: removedSubVariants was already initialized above before the variant check loop
  //   const prevSubVariants = prevProps.testingInfoStates.subVariants;
  //   const currSubVariants = testingInfoStates.subVariants;
  //   if (Array.isArray(prevSubVariants) && !isEqual(prevSubVariants, currSubVariants)) {
  //     const additionalRemoved = prevSubVariants.filter(v => !(Array.isArray(currSubVariants) ? currSubVariants.includes(v) : currSubVariants === v));
  //     removedSubVariants.push(...additionalRemoved);
  //   } else if (prevSubVariants != null && currSubVariants == null) {
  //     if (!removedSubVariants.includes(prevSubVariants)) {
  //       removedSubVariants.push(prevSubVariants);
  //     }
  //   }
  //   // Detect removed material types
  //   // Detect if materialType was added or removed
  //   let materialTypeRemoved = false;
  //   if (!isEqual(prevMaterialTypes, currMaterialTypes)) {
  //     // Removed: present in prevMaterialTypes but not in currMaterialTypes
  //       // If materialType is removed, get its variants, selected variants, and subvariants
  //       materialTypeRemoved = prevMaterialTypes.some(id => id != null && !currMaterialTypes.includes(id));
  //       if (materialTypeRemoved) {
  //       prevMaterialTypes
  //         .filter(id => id != null && !currMaterialTypes.includes(id))
  //       .forEach(removedId => {
  //         // Get variants for removed materialType
  //         const prevVariants = prevProps.testingInfoStates[`variants${removedId}`];
  //         if (Array.isArray(prevVariants)) {
  //           removedVariants.push(...prevVariants);
  //           // Also add selected variants that are still present
  //           const currVariants = testingInfoStates[`variants${removedId}`];
  //           if (Array.isArray(currVariants)) {
  //             selectedVariants.push(...currVariants.filter(v => prevVariants.includes(v)));
  //           }
  //         } else if (prevVariants != null) {
  //           removedVariants.push(prevVariants);
  //         }
  //         // Get subVariants for removed materialType
  //         const prevSubVariants = prevProps.testingInfoStates.subVariants;
  //         if (Array.isArray(prevSubVariants)) {
  //           removedSubVariants.push(...prevSubVariants.filter(v => v === removedId));
  //         } else if (prevSubVariants === removedId) {
  //           removedSubVariants.push(prevSubVariants);
  //         }
  //       });
  //     }
  //   }
  //   // You can use materialTypeAdded and materialTypeRemoved as needed
  //   let removedMaterialTypes = prevMaterialTypes.filter(id => id != null && !currMaterialTypes.includes(id));
  //   // Append removedVariants and removedSubVariants to removedMaterialTypes
  //   removedMaterialTypes = [
  //     ...removedMaterialTypes,
  //     ...removedVariants,
  //     ...removedSubVariants
  //   ];
    
  //   // Remove variants and subVariants for each removed material type
  //   // Get the actual removed material type IDs (not variants/subvariants)
  //   const actualRemovedMaterialTypes = prevMaterialTypes.filter(id => id != null && !currMaterialTypes.includes(id));
    
  //   actualRemovedMaterialTypes.forEach(removedId => {
  //     // Check if this material type has variants defined
  //     const materialTypeData = MaterialTypes.find(mat => mat.id === removedId);
      
  //     // Clear the variant field for the removed material type if it has variants
  //     if (materialTypeData && materialTypeData.variant && testingInfoStates[`variants${removedId}`] != null) {
  //       change(`variants${removedId}`, null);
  //     }
      
  //     // Special handling for material type 405 (Inks and Paints)
  //     // When material type 405 is removed, also clear subVariants
  //     if (removedId === 405) {
  //       change('subVariants', null);
  //     }
  //   });
    
  //   // Now handle clearing for all removed items (material types, variants, and subvariants)
  //   removedMaterialTypes.forEach(removedId => {
  //     // Remove subVariants if they are associated with the removed material type/variant
  //     if (Array.isArray(testingInfoStates.subVariants)) {
  //       const updatedSubVariants = testingInfoStates.subVariants.filter(
  //         subId => subId !== removedId && subId != null
  //       );
  //       change('subVariants', updatedSubVariants.length > 0 ? updatedSubVariants : null);
  //     } else if (testingInfoStates.subVariants === removedId) {
  //       change('subVariants', null);
  //     }
  //   });
  //   // CRITICAL: Only process material type/variant changes if there's an actual change
  //   // Don't trigger when ONLY product type changes (that's handled separately by handleProductTypeChangeOnMount)
  //   const hasProductTypeChange = prevProps.testingInfoStates.currentProductType !== testingInfoStates.currentProductType ||
  //                                 prevProps.productId !== productId;
  //   const hasMaterialTypeChange = !isEqual(prevProps.testingInfoStates.materialType, testingInfoStates.materialType);
  //   const hasSubVariantsChange = !isEqual(prevProps.testingInfoStates.subVariants, testingInfoStates.subVariants);
    
  //   // Skip if ONLY product type changed (test packages already cleared by handleProductTypeChangeOnMount)
  //   if (hasProductTypeChange && !hasMaterialTypeChange && !hasSubVariantsChange && !variantsChanged) {
  //     // Still update the instance variable
  //     const currMaterialTypes = testingInfoStates.materialType || [];
  //     this.prevMaterialTypes = currMaterialTypes ? [...currMaterialTypes] : [];
  //     return;
  //   }
    
  //   if (hasMaterialTypeChange || hasSubVariantsChange || variantsChanged || materialTypeAdded || materialTypeRemoved) {
           
  //     // If material type was added or changed, calculate test packages
  //      // Skip this during Edit mode initial load to preserve saved test packages
  //      if ((materialTypeAdded || variantsChanged) && !materialTypeRemoved) {
  //        const combinedSelection = this.getSelectedMaterialsAndVariants();
  //        this.clearAndRecalculateTestPackages(combinedSelection);
  //      }
       
  //      // If ALL material types were removed (nothing selected anymore), clear all test packages
  //      if (materialTypeRemoved && currMaterialTypes.length === 0 && (!Array.isArray(currSubVariants) || currSubVariants.length === 0)) {
  //        this.clearAndRecalculateTestPackages([]);
  //      }
      
  //     // Remove test packages associated with removed material types
  //     if (removedMaterialTypes.length > 0 && (materialTypeRemoved || variantsChanged || removedSubVariants.length > 0)) {
  //       // CRITICAL: Before removing anything, capture variant values for manually selected test packages
  //       // This ensures we can restore them after removal
  //       const preservedManualVariants = {};
  //       const allTestCategories = ['common', 'packaging', 'jewelry', 'electronic'];
  //       allTestCategories.forEach(category => {
  //         const tests = individualTest[0][category] || [];
  //         const fieldName = category === 'common' ? 'testPackages' : 
  //                           category === 'packaging' ? 'testPackagesPackaging' :
  //                           category === 'jewelry' ? 'testPackagesJewelry' : 'testPackagesElectronic';
          
  //         tests.forEach(test => {
  //           if (test.variants && Array.isArray(test.variants)) {
  //             const isManual = this.isManuallySelected(test.id, fieldName);
  //             if (isManual) {
  //               const variantFieldName = `tp-variants${test.id}`;
  //               const currentVariantValue = testingInfoStates[variantFieldName];
  //               if (currentVariantValue != null) {
  //                 preservedManualVariants[variantFieldName] = currentVariantValue;
  //               }
  //             }
  //           }
  //         });
  //       });
        
  //       // Process removal in a smarter way - handle each removed ID individually
  //       const processedRemovedIds = new Set();
        
  //       removedMaterialTypes.forEach(removedId => {
  //         if (processedRemovedIds.has(removedId)) {
  //           return; // Skip if already processed
  //         }
  //         processedRemovedIds.add(removedId);
          
  //         // Get remaining material types, variants, and subvariants
  //         let remainingMaterialTypes = currMaterialTypes.filter(id => id != null && id !== removedId);
  //         const remainingSubVariants = Array.isArray(currSubVariants) ? currSubVariants.filter(id => id != null && id !== removedId) : [];
          
  //         // Add currently selected variants (excluding the ones being removed)
  //         const currentSelectedVariants = selectedVariants.filter(id => id != null && id !== removedId);
  //         remainingMaterialTypes = remainingMaterialTypes.concat(currentSelectedVariants).concat(remainingSubVariants);
          
  //         // Remove duplicates          
  //         remainingMaterialTypes = Array.from(new Set(remainingMaterialTypes.filter(id => id != null)));
          
  //         // Get test package IDs that should remain
  //         let remainingTestPackageIds = [];
  //         remainingMaterialTypes.forEach(materialId => {
  //           const matchTP1 = tp1MaterialTypes.find(item => item.id === materialId);
  //           if (matchTP1 && Array.isArray(matchTP1.testPackage)) {
  //             remainingTestPackageIds = remainingTestPackageIds.concat(matchTP1.testPackage);
  //           }
  //           if (testingInfoStates.enableTP2 === true) {
  //             const matchTP2 = tp2MaterialTypes.find(item => item.id === materialId);
  //             if (matchTP2 && Array.isArray(matchTP2.testPackage)) {
  //               remainingTestPackageIds = remainingTestPackageIds.concat(matchTP2.testPackage);
  //             }
  //           }
  //         });
  //         remainingTestPackageIds = remainingTestPackageIds.map(id => typeof id === 'object' ? id.id : id);
  //         remainingTestPackageIds = Array.from(new Set(remainingTestPackageIds));
  //         // Get test packages for the removed material type/variant/subvariant
  //         const removedTestPackageIds = this.getTestPackagesForMaterialType(removedId).map(id => typeof id === 'object' ? id.id : id);
  //         // Find test packages that should be removed (present in removed but not in remaining)
  //         // CRITICAL: We must exclude manually selected tests and PFAS tests when repellent is Yes
  //         const uniqueRemovedIds = removedTestPackageIds.filter(id => {
  //           const testIdNum = Number(id);

  //           //Keep Solvent/Residual when Yoga mates requires it.
  //           if (testIdNum === 599 && this.isYogaMateSolventRequired()) {
  //             return false; // Don't remove - Yoga mates is Yes
  //           }
            
  //           // PRIORITY 1: PFAS tests - Keep if repellent is 'Yes' (common tests 607, 597)
  //           if (testIdNum === 607 && testingInfoStates.repellent === 'Yes') {
  //             return false; // Don't remove - repellent is Yes
  //           }
  //           if ((testIdNum === 597) && (testingInfoStates.repellent === 'Yes' || testingInfoStates.foodOrMouth === 'Yes')) {
  //             return false; // Don't remove - repellent or foodOrMouth is Yes
  //           }
            
  //           // PRIORITY 2: PFAS tests - Keep if repellent is 'Yes' (packaging tests 608, 586)
  //           if (testIdNum === 608 && testingInfoStates.repellent === 'Yes') {
  //             return false; // Don't remove - repellent is Yes
  //           }
  //           if ((testIdNum === 586) && (testingInfoStates.repellent === 'Yes' || testingInfoStates.foodOrMouth === 'Yes')) {
  //             return false; // Don't remove - repellent or foodOrMouth is Yes
  //           }
            
  //           // Keep if it's in remaining material types
  //           if (remainingTestPackageIds.includes(id)) {
  //             return false;
  //           }
  //           // Keep if manually selected in ANY category
  //           const isManualCommon = this.isManuallySelected(testIdNum, 'testPackages');
  //           const isManualElectronic = this.isManuallySelected(testIdNum, 'testPackagesElectronic');
  //           const isManualPackaging = this.isManuallySelected(testIdNum, 'testPackagesPackaging');
  //           const isManualJewelry = this.isManuallySelected(testIdNum, 'testPackagesJewelry');
            
  //           if (isManualCommon || isManualElectronic || isManualPackaging || isManualJewelry) {
  //             return false; // Don't remove - manually selected
  //           }
  //           return true; // Include in removal list
  //         });
  //         // Only proceed if there are test packages to remove
  //         if (uniqueRemovedIds.length > 0) {
  //           // Separate variant IDs from regular test IDs
  //           const variantTestIds = [];
  //           const regularTestIds = [];
            
  //           uniqueRemovedIds.forEach(testId => {
  //             const testIdNumber = Number(testId);
  //             let isVariant = false;
              
  //             // Check if this testId is a variant in any category
  //             const categories = ['common', 'packaging', 'jewelry'];
  //             for (const category of categories) {
  //               const variantInfo = this.getParentTestForVariant(testIdNumber, category);
  //               if (variantInfo) {
  //                 variantTestIds.push(testIdNumber);
  //                 isVariant = true;
  //                 break;
  //               }
  //             }
              
  //             if (!isVariant) {
  //               regularTestIds.push(testIdNumber);
  //             }
  //           });
            
  //           // Clear variant selections and parent tests only for actual variants
  //           let updatedArraysFromVariantClear = null;
  //           if (variantTestIds.length > 0) {
  //             updatedArraysFromVariantClear = this.clearVariantSelectionsAndParentTests(variantTestIds);
  //           }
            
  //           // CRITICAL: Restore variants for manually selected test packages BEFORE clearing regular test packages
  //           // This ensures validation sees the correct variant values when test packages are updated
  //           Object.keys(preservedManualVariants).forEach(variantFieldName => {
  //             change(variantFieldName, preservedManualVariants[variantFieldName]);
  //           });
            
  //           // Clear regular test packages
  //           this.clearRegularTestPackages(regularTestIds, uniqueRemovedIds, updatedArraysFromVariantClear, remainingTestPackageIds, remainingMaterialTypes);
  //         }
  //       });
       
  //     } else if (!variantsChanged && !materialTypeAdded) {
  //       // Run this when material types changed but no variants changed and no material was added
  //       // (This handles cases like material type order changes or other edge cases)
  //       const combinedSelection = this.getSelectedMaterialsAndVariants();
  //       this.clearAndRecalculateTestPackages(combinedSelection);
  //     }

  //     // Handle variant changes: when variants change but no material types are removed or added,
  //     // we need to clear old variant test packages and add new ones
  //     // Use actualRemovedMaterialTypes to check only actual material types, not variants
  //     if (variantsChanged && actualRemovedMaterialTypes.length === 0 && !materialTypeAdded) {
  //       const combinedSelection = this.getSelectedMaterialsAndVariants();
  //       // Clear and recalculate test packages for the new variant selection
  //       this.clearAndRecalculateTestPackages(combinedSelection);
  //     }
      
  //     // NOTE: We do NOT clean up manual selections even if they become auto-selected
  //     // This ensures they persist when material types are later removed
  //   }
  // };
  
  componentWillUpdate(nextProps, nextState) {
    const { testingInfoStates, initialValues, initialMaterialTypes, productId, prevProductId } = this.props;
    if (testingInfoStates.recycle === "Yes") {
      recycledContentValue('Yes')
    } else {
      recycledContentValue('No')
    }
    //Edit form to get productId
    if (isNaN(productId) === false) {
      getProductIdEdit(productId)
    }
    else {
      getProductIdEdit('')
    }

    const { resetMaterial } = this.props;
    let packageDiffernce = [], materialDiffernce = [], lastPopMaterial = [], lastPopForFirsttime = [], newMaterialLength = 0;
    let newMaterialList;
    let oldMaterialList;
    let newPackageList;
    let oldPackageList;
    oldPackageList = (testingInfoStates?.testPackages?.length > 0) ? testingInfoStates?.testPackages.filter(function (el) {
      return el != null;
    }) : [];
    newPackageList = (nextProps?.testingInfoStates?.testPackages?.length > 0) ? nextProps?.testingInfoStates?.testPackages.filter(function (el) {
      return el != null;
    }) : [];
    packageDiffernce = (newPackageList?.length > 0) ? newPackageList.filter(x => !oldPackageList.includes(x)) : [];
    if (
      (testingInfoStates.materialType !== nextProps.testingInfoStates.materialType ||
        testingInfoStates[`variants${nextProps.testingInfoStates.materialType}`] !==
        nextProps.testingInfoStates[`variants${nextProps.testingInfoStates.materialType}`]) &&
      nextProps.testingInfoStates.materialType !== null
    ) {
      // isEqualArray will check if the materialtype array has changed.
      // There is one more check added especially for intial value as materialType nextprops and props are same on intial loading
      let isEqualArray = isEqual(nextProps.testingInfoStates.materialType, testingInfoStates.materialType)
      // Will remove in next PR issues got resolved  
      //isEqual(initialMaterialTypes,testingInfoStates.materialType);
      if ((nextProps.testingInfoStates.materialType.filter(element => element !== undefined)).length > 0 && testingInfoStates.materialType) {
        oldMaterialList = testingInfoStates.materialType.filter(function (el) {
          return el != null;
        });
        newMaterialList = nextProps.testingInfoStates.materialType.filter(function (el) {
          return el != null;
        });
        newMaterialLength = nextProps.testingInfoStates.materialType.filter(element => element !== undefined).length;
        materialDiffernce = newMaterialList.filter(x => !oldMaterialList.includes(x));
        lastPopMaterial = oldMaterialList.filter(x => !newMaterialList.includes(x));
        lastPopForFirsttime = (prevProductId !== productId && prevProductId !== 0 && prevProductId !== '')
          ? [] : initialMaterialTypes && initialMaterialTypes.filter(x => !newMaterialList.includes(x))
      }
      //Not using materials -  Need to remove // 
      if ((materialDiffernce.length > 0 && materialDiffernce.includes(417)) ||
        (materialDiffernce.length === 0 && newMaterialLength <= 1 && nextProps.testingInfoStates.materialType.filter(element => element !== undefined).includes(417)) ||
        (isEqualArray && testingInfoStates.materialType.includes(417))
      ) {
        this.toysValidationMessage(
          'If this item is for an Electronic component, the appropriate RSL test package and/or additional test(s) must also be indicated.'
        );
      } else if ((materialDiffernce.length > 0 && materialDiffernce.includes(420)) ||
        (materialDiffernce.length === 0 && newMaterialLength <= 1 && nextProps.testingInfoStates.materialType.filter(element => element !== undefined).includes(420)) ||
        (isEqualArray && testingInfoStates.materialType.includes(420))
      ) {
        this.toysValidationMessage(
          'For the selection Packaging, the appropriate RSL test package and/or additional tests must also be indicated.'
        );
      } else if ((materialDiffernce.length > 0 && materialDiffernce.includes(410)) ||
        (materialDiffernce.length === 0 && newMaterialLength <= 1 && nextProps.testingInfoStates.materialType.filter(element => element !== undefined).includes(410)) ||
        (isEqualArray && testingInfoStates.materialType.includes(410))
      ) {
        this.toysValidationMessage(
          'For the selection OTHER Rhinestones, sequins, etc. , Please select the appropriate RSL Individual Test package from Metals (Nickel Release).'
        );
      }
      // for deselecting the test packages for both edit and create trf
      if ((isEqualArray && lastPopForFirsttime.includes(417)) ||
        (lastPopMaterial.includes(417) && nextProps.testingInfoStates.testPackagesElectronic && nextProps.testingInfoStates.testPackagesElectronic.filter(element => element !== null).length > 0
        )) {
        this.toysValidationMessage(
          'You have an individual test package selected for the Material type - Electronics'
        );
      }
      else if ((isEqualArray && lastPopForFirsttime.includes(420)) ||
        (lastPopMaterial.includes(420) && nextProps.testingInfoStates.testPackagesPackaging && nextProps.testingInfoStates.testPackagesPackaging.filter(element => element !== null).length > 0)) {
        this.toysValidationMessage(
          'You have an individual test package selected for the Material type - Packaging'
        );
      } //Not using materials -  Need to remove till here// 
    }

    if (nextProps.testingInfoStates.materialType && testingInfoStates[`variants409`] !== nextProps.testingInfoStates[`variants409`]) {
      if (
        (nextProps.testingInfoStates.materialType.filter(element => element !== undefined).includes(409)) &&
        nextProps.testingInfoStates[`variants409`] === 4091
      ) {
        this.toysValidationMessage(
          'For the selection Metal items(Not coated or painted items;  direct skin contact), Please select the appropriate RSL Individual Test package from Metals (Nickel Release).'
        );
      } else if (
        (nextProps.testingInfoStates.materialType.filter(element => element !== undefined).includes(409)) &&
        nextProps.testingInfoStates[`variants409`] === 4093
      ) {
        this.toysValidationMessage(
          'For the selection Metal items(Coated or Painted Items; direct skin contact) is checked, Please select the appropriate RSL Individual Test package from Metals (Nickel Release).'
        );
      }
    }

    if (nextProps.testingInfoStates.testPackages && JSON.stringify(testingInfoStates.testPackages) !== JSON.stringify(nextProps.testingInfoStates.testPackages)) {
      if ((nextProps.testingInfoStates.testPackages.filter(element => element !== undefined).includes(603) && packageDiffernce.includes(603)) || (nextProps.testingInfoStates.testPackages.filter(element => element !== undefined).includes(604) && packageDiffernce.includes(604)) || (nextProps.testingInfoStates.testPackages.filter(element => element !== undefined).includes(529) && packageDiffernce.includes(529))) {
        this.toysValidationMessage(
          'Please work with RSL Support Team to discuss this testing further: RSLSupport@nike.com'
        );
      }
    }

    if (
      testingInfoStates.repellent !== nextProps.testingInfoStates.repellent &&
      nextProps.testingInfoStates.repellent === 'No' &&
      nextProps.testingInfoStates.testingInfoStatus === 'Edit' &&
      Array.isArray(nextProps.testingInfoStates.testPackages)
    ) {
      const repellentOnlyPFASIndex = nextProps.testingInfoStates.testPackages.findIndex(pkg => Number(pkg) === 607);
      if (repellentOnlyPFASIndex !== -1) {
        nextProps.testingInfoStates.testPackages[repellentOnlyPFASIndex] = null;
      }
    }
    if (testingInfoStates.materialType !== nextProps.testingInfoStates.materialType && resetMaterial && nextProps.testingInfoStates.testingInfoStatus === 'Edit') {

      const { change } = this.props;
      nextProps.testingInfoStates.materialType.filter(element => element != null).map(id => (
        change(`variants${id}`, null)
      ));
      change('materialType', [null]);
      this.setState({ resetMaterial: false })

    }
    if (testingInfoStates.testPackages !== nextProps.testingInfoStates.testPackages && nextProps.testingInfoStates.testingInfoStatus === 'Edit') {
    } if (initialValues.refId !== nextProps.initialValues.refId && nextProps.initialValues.testingInfoStatus === 'Edit') {
      const { change } = this.props;
      change(`refId`, nextProps.initialValues.refId);

    }
    else if (testingInfoStates.testmaterialName !== nextProps.testingInfoStates.testmaterialName && testingInfoStates.testingInfoStatus === 'Edit') {
      const { change } = this.props;
      change(`refId`, nextProps.initialValues.refId);

    }
  }
  resetTestingType = () => {
    const { change, testingInfoStates } = this.props;
    const materialNullArry = new Array(MaterialTypes.length).fill(null);
    const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
    testingInfoStates.materialType && testingInfoStates.materialType.filter(element => element != null).forEach(id => {
      change(`subVariants`, 0);
    });
    testingInfoStates.materialType.filter(element => element != null).forEach(id => {
      change(`variants${id}`, null);
    });
    change('materialType', materialNullArry);
    change('testPackagesElectronic', testPackagesElectronicNullArry)
    change('jeweleryMaterialType', '')
    change('electCategory', '')
    change('materialNames', [null]);
    if (testingInfoStates.testingInfoStatus === 'Edit') {
      this.setState({ resetMaterial: true })
    }
  };

  closeSubmitModal = status => {
    this.setState({ submitModal: status });
  };

  toysValidationMessage = message => {
    this.setState({ submitModal: true, message });
  };
  sortDynamic = (key, order = 'asc') => {
    const sortOrder = order === 'asc' ? 1 : -1
    return (a, b) => {
      const A = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
      const B = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];
      if (A < B) {
        return sortOrder * -1
      } else if (A > B) {
        return sortOrder * 1
      } else {
        return 0
      }
    }
  }

  modifyData = data => {
    if (data.length >= 3) {
      var mod = data.length % 3;
      var colLength = data.length / 3;
      var tableArr = [];
      var _ndEle = mod === 2 ? Math.trunc(colLength) + 1 : Math.trunc(colLength) + mod;
      var rowLength = Math.trunc(colLength);
      var roundoff = Math.round(colLength);
      for (var i = 0; i < _ndEle; i++) {
        if (i === 0) {
          tableArr.push(data[0]);
          tableArr.push(data[_ndEle]);
          mod === 2 ? tableArr.push(data[_ndEle + roundoff]) : tableArr.push(data[_ndEle + rowLength]);
        } else {
          if (mod === 2) {
            tableArr.length < data.length && tableArr.push(data[i]);
            tableArr.length < data.length && tableArr.push(data[i + roundoff]);
            tableArr.length < data.length && tableArr.push(data[i + roundoff + roundoff]);
          }
          else if ((i + _ndEle + rowLength - 1) < data.length && mod !== 2) {
            tableArr.push(data[i]);
            if (mod === 1) {
              (i + _ndEle + rowLength) !== tableArr.length && tableArr.push(data[i + _ndEle]);
              (i + _ndEle + rowLength) !== tableArr.length && tableArr.push(data[i + _ndEle + rowLength]);
            }
            else if ((i + _ndEle + rowLength) !== data.length) {
              tableArr.push(data[i + _ndEle])
              tableArr.push(data[i + _ndEle + rowLength])
            }
          }
        }
      }
      return tableArr;
    }
    return data
  }
  handleChange = (event) => {
    const { onChangeScreeningInkVarient } = this.props;
    if (event.target.value === '4040') {
      onChangeScreeningInkVarient(0)
    } else if (event.target.value === '4052') {
      onChangeScreeningInkVarient(parseInt(event.target.value))
    }
  }
  skinContactHandleChange = (event) => {
    const { change, testingInfoStates } = this.props
    if (event.target.value === 'Yes' && (testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')) {
      this.toysValidationMessage(
        'Select from the Material Types under the PRODUCT RSL TESTS section'
      );
    } else if (event.target.value === 'No' && testingInfoStates.testingType === 'PR') {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      change('electCategory', '')
      this.radioButtonMaterialValues('clear', "electronic-test")
      change('testPackagesElectronic', testPackagesElectronicNullArry)
    }
    else if (event.target.value === 'Yes' && testingInfoStates.testingType === 'RD') {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      change('electCategory', '')
      this.radioButtonMaterialValues('clear', "electronic-test")
      change('testPackagesElectronic', testPackagesElectronicNullArry)
    }
  }
  radioButtonMaterialValues = (materialId, materialCategory) => {
    const { change, testingInfoStates } = this.props
    var rslTests = MaterialTypes.filter(data => data.category === "rsl-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    rslTests = this.modifyData(rslTests);
    var otherTest = MaterialTypes.filter(data => data.category === "other-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    otherTest = this.modifyData(otherTest);
    const packagingTests = MaterialTypes.filter(data => data.category === "packaging-test" && data.isTestAvailable === true);
    var packagingTestSort = packagingTests.sort(this.sortDynamic('label'));
    packagingTestSort = this.modifyData(packagingTestSort);
    var jewelryTest = MaterialTypes.filter(data => data.category === "jewelry-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    var electronicTest = MaterialTypes.filter(data => data.category === "electronic-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    electronicTest = this.modifyData(electronicTest);
    var allMaterialTypes = rslTests.concat(otherTest).concat(packagingTestSort).concat(jewelryTest).concat(electronicTest);
    var materialIdInt = materialId
    // Create a copy of the array to avoid mutating the original reference
    var materialTypeData = Array.isArray(testingInfoStates.materialType) ? [...testingInfoStates.materialType] : []
    if (materialId === 'clear') {
      allMaterialTypes.map((value, index) => {
        if (value.category === materialCategory) {
          materialTypeData[index] = null
        }
        return materialTypeData
      })
      change('materialType', materialTypeData)
    } else {
      allMaterialTypes.map((value, index) => {
        if (value.id === materialIdInt && value.category === materialCategory) {
          materialTypeData[index] = materialIdInt
        }
        else if (value.category === materialCategory) {
          materialTypeData[index] = null
        }
        return materialTypeData
      })
      change('materialType', materialTypeData)
    }
  }
  electCategoryHandleChange = (event) => {
    const { change, testingInfoStates, productId } = this.props
    if (event === 4150 && (testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')) {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      testPackagesElectronicNullArry.splice(0, 0, 555)
      change('testPackagesElectronic', testPackagesElectronicNullArry)
      this.setState({ electronicClearbtn: false })
      this.radioButtonMaterialValues(event, "electronic-test")
      change("electCategory", "electrical")
    } else if (event === 4152 && (testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')) {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      testPackagesElectronicNullArry.splice(1, 0, 556)
      change('testPackagesElectronic', testPackagesElectronicNullArry)
      this.setState({ electronicClearbtn: false })
      this.radioButtonMaterialValues(event, "electronic-test")
      change("electCategory", "battery")
    }
    else if (event === 4150 && testingInfoStates.testingType === 'RD' && productId === 206) {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      testPackagesElectronicNullArry.splice(0, 0, 555)
      change('testPackagesElectronic', testPackagesElectronicNullArry)
      this.setState({ electronicClearbtn: false })
    } else if (event === 4152 && testingInfoStates.testingType === 'RD' && productId === 206) {
      const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
      testPackagesElectronicNullArry.splice(1, 0, 556)
      change('testPackagesElectronic', testPackagesElectronicNullArry)
      this.setState({ electronicClearbtn: false })
    }
  }
  clearJewelryRadioButtons = () => {
    const { change, testingInfoStates } = this.props
    change("jeweleryMaterialType", " ")
    this.radioButtonMaterialValues('clear', "jewelry-test")
    this.setState({ jewelryClearbtn: true })
    testingInfoStates.materialType && testingInfoStates.materialType.filter(element => element != null).forEach(id => {
        change(`variants${id}`, null);
    });
  }

  clearElectronicRadioButtons = () => {
    const { change } = this.props
    const testPackagesElectronicNullArry = new Array(individualTest[0].electronic.filter(data => data.isTestAvailable === true).length).fill(null);
    change('electCategory', '')
    change('testPackagesElectronic', testPackagesElectronicNullArry)
    this.radioButtonMaterialValues('clear', "electronic-test")
    this.setState({ electronicClearbtn: true })
  }

  jewelryHandleChange = (event) => {
    const { change } = this.props
    change("jeweleryMaterialType", event)
    if (event === 4148) {
      this.setState({ jewelryClearbtn: false })
      this.radioButtonMaterialValues(event, "jewelry-test")
    } else if (event === 4144) {
      this.setState({ jewelryClearbtn: false })
      this.radioButtonMaterialValues(event, "jewelry-test")
    } else if (event === 4147) {
      this.setState({ jewelryClearbtn: false })
      this.radioButtonMaterialValues(event, "jewelry-test")
    } else if (event === 4143) {
      this.setState({ jewelryClearbtn: false })
      this.radioButtonMaterialValues(event, "jewelry-test")
    }
  }
 onToggleSwitchChange = (arg) => {
    const { change, returnTp1Tp2Type, testingInfoStates } = this.props;
    const checked = typeof arg === 'boolean'
      ? arg
      : (arg && arg.target ? !!arg.target.checked : !!arg?.checked);
    // Store the previous enableTP2 state for comparison
    //const previousTP2State = testingInfoStates.enableTP2; 
    const trfCountDivisibleBy5 = Number.isInteger(testingInfoStates?.trfCount) && testingInfoStates.trfCount % 5 === 0;
    if (returnTp1Tp2Type && typeof returnTp1Tp2Type.trfCount === 'number' 
      && testingInfoStates && testingInfoStates.testingInfoStatus === "New") {
      const tp2Status = this.returnTp2Logic(returnTp1Tp2Type.trfCount);
      if (!tp2Status) {
        change('enableTP2', checked);
        this.setState({ enableTP2Message: tp1tp2Msg });
        
      } else {
        change('enableTP2', true);
        this.setState({ enableTP2Message: tp1tp2Msg });
      }
    } else if (returnTp1Tp2Type && typeof returnTp1Tp2Type.trfCount === 'number' 
      && testingInfoStates && testingInfoStates.testingInfoStatus === "Edit") {
      const tp2Status = this.returnTp2Logic(returnTp1Tp2Type.trfCount);      
      if (!tp2Status) {
        change('enableTP2', checked);
        this.setState({ enableTP2Message: tp1tp2Msg });
        
      } else {
        change('enableTP2', true);
        this.setState({ enableTP2Message: tp1tp2Msg });
      }
    } else if (testingInfoStates && testingInfoStates.testingInfoStatus === "Edit" && returnTp1Tp2Type === undefined) {
      if (testingInfoStates.initialTp2EnableStatusEdit === true && trfCountDivisibleBy5) {
        change('enableTP2', true);
        this.setState({ enableTP2Message: tp1tp2Msg });
      } else {
        change('enableTP2', checked);
        this.setState({ enableTP2Message: 'TP2 can be disabled/enabled.' });
      }
    }
  }

  // Helper: apply Natural Materials (Paper & Cardboard) rules for Bisphenols (583) and Total Heavy Metals (536).
  // Mutates finalPackagingArray and variantUpdates in place.
  applyNaturalMaterialPackaging = (selectedMaterialTypes, finalPackagingArray, indices, variantUpdates, shouldIncludeTP2) => {
    const { testingInfoStates, getRecycledContentValue } = this.props;
    const isRecycleYes = testingInfoStates.recycle === 'Yes' || getRecycledContentValue === 'Yes';
    const is6020 = selectedMaterialTypes.includes(6020); // receipt paper
    const is6021 = selectedMaterialTypes.includes(6021); // non-receipt paper

    // Bisphenols (583):
    // - Receipt paper (6020): always add, variant 621 (Receipt Paper)
    // - Non-receipt paper (6021) + recycled: add, variant 615 (Composite)
    // - Otherwise: remove ONLY if 583 is not already mapped from the TP1/TP2 matrix
    //   for other selected material types (e.g. 6015, 6018, 6017, 6010, 6019).
    //   Without this guard applyNaturalMaterialPackaging would wipe the matrix-added
    //   selection, leaving the checkbox disabled-but-unchecked.
    if (is6020) {
      if (indices[583] !== -1) {
        finalPackagingArray[indices[583]] = 583;
        variantUpdates['tp-variants583'] = [621];
      }
    } else if (is6021 && isRecycleYes) {
      if (indices[583] !== -1) {
        finalPackagingArray[indices[583]] = 583;
        variantUpdates['tp-variants583'] = [615];
      }
    }
    // } else if (indices[583] !== -1 && !this.isManuallySelected(583, 'testPackagesPackaging')) {
    //   finalPackagingArray[indices[583]] = null;
    // }

    // Total Heavy Metals (536): natural material + recycled + TP2 enabled → add; otherwise remove
    if (is6020 || is6021) {
      if (isRecycleYes && shouldIncludeTP2) {
        if (indices[536] !== -1) {
          finalPackagingArray[indices[536]] = 536;
        }
      } 
      // else if (indices[536] !== -1 && !this.isManuallySelected(536, 'testPackagesPackaging')) {
      //   finalPackagingArray[indices[536]] = null;
      // }
    }
  }

  // handle input change
  handleInputChange = (e, index) => {
    const { change } = this.props
    const { getInitialCertificationArry, initialCertificationArry } = this.props
    const { name, value } = e.target;
    const list = getInitialCertificationArry;
    list[index][name] = value;
    if (value === 'other') {
      const otherKay = "other";
      list[index][otherKay] = "sample"
      list[index][name] = ""
    }
    initialCertificationArry(list)
    change('certification', getInitialCertificationArry)
    if (getInitialCertificationArry) {
      const { getInitialCertificationArry } = this.props
      const editCertificationArry = getInitialCertificationArry
      editCertificationArry.map(item => {
        if (item.name === 'oeko' || item.name === 'bluesign' || item.name === 'eco') {
          delete item.other
        }
        return item
      })
    }
  };
  // handle click event of the Remove button
  handleRemoveClick = (index) => {
    const { getInitialCertificationArry, initialCertificationArry } = this.props
    const list = getInitialCertificationArry;
    list.splice(index, 1);
    initialCertificationArry(list)
  };

  // handle click event of the Add button
  handleAddClick = (e) => {
    e.preventDefault();
    const { getInitialCertificationArry, initialCertificationArry } = this.props
    const cerObj = { name: '', number: '' }
    if (getInitialCertificationArry.length <= 5) {
      initialCertificationArry([...getInitialCertificationArry, cerObj])
    }
  };
  certificationAddMore = () => {
    const { getInitialCertificationArry } = this.props
    return (
      getInitialCertificationArry && getInitialCertificationArry.map((x, i) => {
        return (
          <Fragment>
            <div className="ncss-col-sm-12 ncss-input-container">
              <div className="ncss-col-sm-3 ncss-input-container">
                <select id="select" name="name" onChange={(e) => this.handleInputChange(e, i)}
                  className="Select-input select-input-font ncss-input pt2-sm pr4-sm pb2-sm pl4-sm dropdown-border-location">
                  <option value="" selected="selected">Select Certificate</option>
                  {certification.map(data => (
                    <option key={data.label} value={data.value} selected={(x.name === data.value) ? true
                      : (x.name !== 'oeko' && x.name !== 'bluesign' && x.name !== 'eco' && x.name !== '') ? true
                        : false ? 'selected' : ''}>
                      {data.label}
                    </option>
                  ))}
                </select></div>
              {x.other !== '' && typeof x.other !== 'undefined' ? (
                <div className="ncss-col-sm-3 ncss-input-container">
                  <input
                    className="ncss-input pt2-sm pr4-sm pb2-sm pl4-sm"
                    placeholder="Certificate Name"
                    value={x.name}
                    name="name"
                    onChange={(e) => this.handleInputChange(e, i)}
                  /></div>
              ) : ''
              }
              <div className="ncss-col-sm-3 ncss-input-container">
                <input
                  className="ncss-input pt2-sm pr4-sm pb2-sm pl4-sm"
                  placeholder="Certificate Number"
                  value={x.number}
                  name="number"
                  onChange={(e) => this.handleInputChange(e, i)}
                /></div>
              <div className="ncss-col-sm-3 ncss-input-container">
                {getInitialCertificationArry.length - 1 === i && (
                  <Button className="ncss-col-sm-2 download-print-button-FRF u-bold pb1-sm text-color-accent" onClick={(e) => this.handleAddClick(e)}>Add</Button>
                )}
                {getInitialCertificationArry.length !== 1 && (
                  <Button className=" ncss-col-sm-2 download-print-button-FRF u-bold pb1-sm addmore-error" onClick={() => this.handleRemoveClick(i)}>
                    Remove
                  </Button>
                )}
              </div>
            </div>
          </Fragment>
        );
      }))
  }

  // Helper method to get processed arrays and PFAS test indices
  getProcessedArraysAndIndices = () => {
    const { testingInfoStates, productId } = this.props;
    
    // Get processed common array - apply same filters as render method
    let common = individualTest[0].common.filter(data => data.isTestAvailable === true);
    
    // Apply the same filtering logic as the render method to ensure array structure matches
    if (testingInfoStates && (testingInfoStates.currentProductType === 202 || productId === 202)) {
      if (testingInfoStates.eyeWear === 'Yes') {
        // Show 619 (Phthalates Eyewear), hide 530 (regular Phthalates)
        common = common.filter(data => data.id !== 530);
      } else {
        // Show 530 (regular Phthalates), hide 619 (Phthalates Eyewear)
        common = common.filter(data => data.id !== 619);
      }
    } else if (testingInfoStates && (testingInfoStates.currentProductType !== 202 && productId !== 202)) {
      // For non-Equipment products, always show 530 and hide 619
      common = common.filter(data => data.id !== 619);
    }
    
    common.sort(this.sortDynamic('label'));
    common = this.modifyData(common);
    
    // Get processed packaging array
    let packaging = individualTest[0].packaging.filter(data => data.isTestAvailable === true);
    packaging.sort(this.sortDynamic('label'));
    packaging = this.modifyData(packaging);
    
    // Find PFAS test indices
    const indices = {
      597: common.findIndex(item => item.id === 597),
      607: common.findIndex(item => item.id === 607),
      599: common.findIndex(item => item.id === 599),
      586: packaging.findIndex(item => item.id === 586),
      608: packaging.findIndex(item => item.id === 608),
      583: packaging.findIndex(item => item.id === 583),
      536: packaging.findIndex(item => item.id === 536)
    };
    
    return { common, packaging, indices };
  };

  // Helper method to check if an index corresponds to a PFAS test in the given array
  isPFASTestIndex = (index, testArray, testId) => {
    return testArray[index] && testArray[index].id === testId;
  };
  
  // Helper method to get the correct index for a packaging test package
  getIndexFromPackaging = (testId) => {
    // Get the processed packaging array (sorted and filtered)
    let packaging = individualTest[0].packaging.filter(data => data.isTestAvailable === true);
    packaging.sort(this.sortDynamic('label'));
    packaging = this.modifyData(packaging);
    
    // Find the index of the test package in the processed packaging array
    return packaging.findIndex(test => test.id === testId);
  };
  
  // Helper function to add packaging test package at correct index
  addPackagingTestPackageAtIndex = (packages, id, fallbackIndex) => {
    if (!packages.includes(id)) {
      const index = this.getIndexFromPackaging(id);
      const targetIndex = index !== -1 ? index : fallbackIndex;
      if (targetIndex >= 0 && targetIndex < packages.length) {
      packages[targetIndex] = id;
      }
    }
  }

  testPackageForPFAS = (event) => {
    const { testingInfoStates, change, productId } = this.props
    // Get processed arrays and indices
    const { indices } = this.getProcessedArraysAndIndices();
    
    var containsTestClass = testingInfoStates.testPackages.every(i => [597, 607].includes(i))
    var containsTestClassPackage = testingInfoStates.testPackages.every(i => [586, 608].includes(i))
    
    if (event.target.value === 'PR' || event.target.value === 'RD') {
      if (!containsTestClass) {
        if (testingInfoStates.repellent === 'Yes' && (productId === 200 || productId === 201 || productId === 206)) {
          const testPackagePFAS = testingInfoStates.testPackages;
          if (indices[597] !== -1) testPackagePFAS[indices[597]] = 597;
          if (indices[607] !== -1) testPackagePFAS[indices[607]] = 607;
          change('testPackages', testPackagePFAS)
        }
      }
    } else if (event.target.value === 'Yes') {
      if ((testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')
        && (productId === 200 || productId === 201 || productId === 206)) {//Repellent Value as Yes & Product Type as AP/FW/EQ/Accessories
        if (!containsTestClass) {
          const testPackagePFAS = testingInfoStates.testPackages;
          if(event.target.name === 'repellent'){//Repellent value yes
            if (indices[597] !== -1) testPackagePFAS[indices[597]] = 597;
            if (indices[607] !== -1) testPackagePFAS[indices[607]] = 607;
          change('testPackages', testPackagePFAS)
          }
          if(event.target.name === 'foodOrMouth' && testingInfoStates.repellent !== 'Yes' ){
            if (indices[597] !== -1) testPackagePFAS[indices[597]] = 597;
            change('testPackages', testPackagePFAS)
          }
           if(event.target.name === 'foodOrMouth' && testingInfoStates.repellent === 'Yes' ){
            if (indices[597] !== -1) testPackagePFAS[indices[597]] = 597;
            if (indices[607] !== -1) testPackagePFAS[indices[607]] = 607;
            change('testPackages', testPackagePFAS)
          }
          
        }
      } 
      //only for Packaging Product Type
      else if ((testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')
        && (productId === 203)) {//debugger //Repellent Value as Yes & Product Type as PK
        if (!containsTestClassPackage) {
          /* const testPackagesPackagingPFAS = testingInfoStates.testPackagesPackaging;
          if (event.target.name === 'repellent') {
            if (indices[586] !== -1) testPackagesPackagingPFAS[indices[586]] = 586;
            if (indices[608] !== -1) testPackagesPackagingPFAS[indices[608]] = 608;
          }
          if (event.target.name === 'foodOrMouth' && testingInfoStates.repellent !== 'Yes') {
            if (indices[586] !== -1) testPackagesPackagingPFAS[indices[586]] = 586;
          }
          change('testPackagesPackaging', testPackagesPackagingPFAS) */
          this.packagingProductTypePFAS(event);
        }
      }
    } else if (event.target.value === 'No') {
      if ((testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')
        && (productId === 200 || productId === 201 || productId === 202 ||productId === 206)) {//Repellent Value as Yes & Product Type as AP/FW/EQ/Accessories     
        if (testingInfoStates.testPackages.includes(597) === true && event.target.name === 'repellent' && testingInfoStates.foodOrMouth !== 'Yes') {
          const testPackagePFAS = testingInfoStates.testPackages;
          const index = testPackagePFAS.indexOf(597);
          testPackagePFAS[index] = null;
          change('testPackages', testPackagePFAS);
        }
        if (testingInfoStates.testPackages.includes(597) === true && event.target.name === 'foodOrMouth' && testingInfoStates.repellent !== 'Yes') {
          const testPackagePFAS = testingInfoStates.testPackages;
          const index = testPackagePFAS.indexOf(597);
          testPackagePFAS[index] = null;
          change('testPackages', testPackagePFAS);
        }
        if (testingInfoStates.testPackages.includes(607) === true && event.target.name === 'repellent') {
          const testPackagePFAS = testingInfoStates.testPackages;
          const index = testPackagePFAS.indexOf(607);
          if (index > -1) {
            testPackagePFAS[index] = null;
          }
          change('testPackages', testPackagePFAS);
        }
      } else if ((testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD')
        && (productId === 203)) {
       this.packagingProductTypePFAS(event);
      }
    }
  }

  packagingProductTypePFAS = (event) => {
        const { testingInfoStates, change } = this.props;
        const packages = [...testingInfoStates.testPackagesPackaging];
        const nextFood = event.target.name === 'foodOrMouth' ? event.target.value : testingInfoStates.foodOrMouth;
        const nextRep = event.target.name === 'repellent' ? event.target.value : testingInfoStates.repellent;

        // F=No && R=No -> remove 586 and 608
        if (nextFood === 'No' && nextRep === 'No') {
          const updated = packages.map(id => {
            if (id === 586) return null;
            if (id === 608) return null;
            return id;
          });
          change('testPackagesPackaging', updated);
        }
        // F=No && R=Yes -> add 586 and 608
        else if (nextFood === 'No' && nextRep === 'Yes') {
          this.addPackagingTestPackageAtIndex(packages, 586, 5);
          this.addPackagingTestPackageAtIndex(packages, 608, 11);
          change('testPackagesPackaging', packages);
        }
        // F=Yes && R=No -> add 586 and remove 608
        else if (nextFood === 'Yes' && nextRep === 'No') {
          this.addPackagingTestPackageAtIndex(packages, 586, 5);
          const idx608 = packages.indexOf(608);
          if (idx608 !== -1) packages[idx608] = null;
          change('testPackagesPackaging', packages);
        }
        // F=Yes && R=Yes -> add 586 and 608
        else if (nextFood === 'Yes' && nextRep === 'Yes') {
          this.addPackagingTestPackageAtIndex(packages, 586, 5);
          this.addPackagingTestPackageAtIndex(packages, 608, 11);
          change('testPackagesPackaging', packages);
        } 

  }

  recycledContentHandleChange = (event) => {
    const { recycledContentValue } = this.props;
    const nextRecycleValue = event.target.value === 'Yes' ? 'Yes' : 'No';
    recycledContentValue(nextRecycleValue);
  }



 /// Initialize manual selections from current test package arrays (for Edit mode)
  initializeManualSelectionsFromCurrentState = () => {
    // Get manual test IDs (those not auto-selected from material types)
    const manualTestIds = this.getManualTestPackages();
    
    // Create Sets for each category
    const updatedManualSelections = {
      testPackages: new Set(),
      testPackagesElectronic: new Set(),
      testPackagesPackaging: new Set(),
      testPackagesJewelry: new Set()
    };
    
    // Map each manual test to its correct category
    manualTestIds.forEach(testId => {
      const testIdNum = Number(testId);
      
      // Check which category this test belongs to
      const inCommon = individualTest[0].common.some(t => t.id === testIdNum);
      const inPackaging = individualTest[0].packaging.some(t => t.id === testIdNum);
      const inJewelry = individualTest[0].jewelry.some(t => t.id === testIdNum);
      const inElectronic = individualTest[0].electronic.some(t => t.id === testIdNum);
      
      if (inCommon) {
        updatedManualSelections.testPackages.add(testIdNum);
      } else if (inPackaging) {
        updatedManualSelections.testPackagesPackaging.add(testIdNum);
      } else if (inJewelry) {
        updatedManualSelections.testPackagesJewelry.add(testIdNum);
      } else if (inElectronic) {
        updatedManualSelections.testPackagesElectronic.add(testIdNum);
      }
    });
    
    this.setState({
      manuallySelectedTests: updatedManualSelections
    });
  };

  // Helper method to toggle manual test selection
  // toggleManualSelection = (testId, testType = 'testPackages', isSelecting = true) => {
  //   const { change, testingInfoStates } = this.props;
  //   const testIdNum = Number(testId);
    
  //   // Use functional setState to ensure we're working with latest state
  //   this.setState((prevState) => {
  //     const newSet = new Set(prevState.manuallySelectedTests[testType]);
      
  //     if (isSelecting) {
  //       // User is selecting this test - ALWAYS track it as manually selected
  //       // This ensures variants are preserved even if the test is also auto-selected
  //       newSet.add(testIdNum);

  //       if (testIdNum === 593) {
  //         change('bisphenol593Manual', true);
  //       }
        
  //       // Add variants for this test if it has any
  //       // EXCEPT for Bisphenols (593, 583) -  user must manually select those variants
  //       const isBisphenols = testIdNum === 593 || testIdNum === 583;
  //       const category = testType === 'testPackagesPackaging' ? 'packaging' 
  //                       : testType === 'testPackagesJewelry' ? 'jewelry'
  //                       : testType === 'testPackagesElectronic' ? 'electronic'
  //                       : 'common';
  //       const testPackageObj = find(individualTest[0][category], ['id', testIdNum]);
        
  //       if (!isBisphenols && testPackageObj && testPackageObj.variants && Array.isArray(testPackageObj.variants) && testPackageObj.variants.length > 0) {
  //         const variantFieldName = `tp-variants${testIdNum}`;
  //         const allVariantIds = testPackageObj.variants.map(v => v.id);
  //         change(variantFieldName, allVariantIds);
  //       }
  //     } else {
  //       const variantFieldName = `tp-variants${testIdNum}`;
  //       change(variantFieldName, null);
  //       // User is deselecting this test - remove from manual selections
  //       newSet.delete(testIdNum);

  //       if (testIdNum === 593) {
  //         change('bisphenol593Manual', null);
  //       }
        
  //       // Remove the test from the testPackages array
  //       const currentTestPackages = testingInfoStates[testType];
  //       if (Array.isArray(currentTestPackages)) {
  //         const index = currentTestPackages.indexOf(testIdNum);
  //         if (index !== -1) {
  //           change(`${testType}[${index}]`, null);
  //         }
  //       }
  //     }
      
  //     return {
  //       manuallySelectedTests: {
  //         ...prevState.manuallySelectedTests,
  //         [testType]: newSet
  //       }
  //     };
  //   });
  // };

  // Manual selections are tracked naturally through user clicks and are NOT cleaned up
  // even if they become auto-selected from material types. This ensures they persist
  // when material types are later removed.

  // Initialize manual selections based on existing test packages when form loads (for backward compatibility)
  // initializeManualSelections = () => {
  //   // Get manual test IDs (those not auto-selected from material types)
  //   const manualTestIds = this.getManualTestPackages();
    
  //   // Create Sets for each category
  //   const updatedManualSelections = {
  //     testPackages: new Set(),
  //     testPackagesElectronic: new Set(),
  //     testPackagesPackaging: new Set(),
  //     testPackagesJewelry: new Set()
  //   };
    
  //   // Map each manual test to its correct category
  //   manualTestIds.forEach(testId => {
  //     const testIdNum = Number(testId);
      
  //     // Check which category this test belongs to
  //     const inCommon = individualTest[0].common.some(t => t.id === testIdNum);
  //     const inPackaging = individualTest[0].packaging.some(t => t.id === testIdNum);
  //     const inJewelry = individualTest[0].jewelry.some(t => t.id === testIdNum);
  //     const inElectronic = individualTest[0].electronic.some(t => t.id === testIdNum);
      
  //     if (inCommon) {
  //       updatedManualSelections.testPackages.add(testIdNum);
  //     } else if (inPackaging) {
  //       updatedManualSelections.testPackagesPackaging.add(testIdNum);
  //     } else if (inJewelry) {
  //       updatedManualSelections.testPackagesJewelry.add(testIdNum);
  //     } else if (inElectronic) {
  //       updatedManualSelections.testPackagesElectronic.add(testIdNum);
  //     }
  //   });
    
  //   // this.setState({
  //   //   manuallySelectedTests: updatedManualSelections
  //   // });
  // };

  // Helper method to preserve manually selected tests during recalculation
  // preserveManualSelections = (currentArray, testType = 'testPackages') => {
  //   const { manuallySelectedTests } = this.state;
  //   const { testingInfoStates, productId } = this.props;
  //   const manualSelections = manuallySelectedTests[testType];
    
  //   // If no manual selections, return as is
  //   if (!Array.isArray(currentArray) || manualSelections.size === 0) {
  //     return currentArray;
  //   }
    
  //   // Get the current testPackages from form state to check what user has currently
  //   const currentFormTestPackages = testingInfoStates[testType] || [];
  //   const currentFormTestPackageIds = new Set(
  //     currentFormTestPackages.filter(id => id !== null && id !== undefined)
  //   );
    
  //   // Get the test data to map IDs to indices
  //   let testData;
  //   switch (testType) {
  //     case 'testPackagesElectronic':
  //       testData = individualTest[0].electronic.filter(data => data.isTestAvailable === true);
  //       testData.sort(this.sortDynamic('label'));
  //       testData = this.modifyData(testData);
  //       break;
  //     case 'testPackagesPackaging':
  //       testData = individualTest[0].packaging.filter(data => data.isTestAvailable === true);
  //       testData.sort(this.sortDynamic('label'));
  //       testData = this.modifyData(testData);
  //       break;
  //     case 'testPackagesJewelry':
  //       testData = individualTest[0].jewelry.filter(data => data.isTestAvailable === true);
  //       testData.sort(this.sortDynamic('label'));
  //       testData = this.modifyData(testData);
  //       break;
  //     default:
  //       // For testPackages (common), apply the same filters as render method
  //       testData = individualTest[0].common.filter(data => data.isTestAvailable === true);
  //       const { testingInfoStates } = this.props;
  //       if (testingInfoStates && testingInfoStates.currentProductType === 202) {
  //         if (testingInfoStates.eyeWear === 'Yes') {
  //           // Show 619 (Phthalates Eyewear), hide 530 (regular Phthalates)
  //           testData = testData.filter(data => data.id !== 530);
  //         } else {
  //           // Show 530 (regular Phthalates), hide 619 (Phthalates Eyewear)
  //           testData = testData.filter(data => data.id !== 619);
  //         }
  //       } else if (testingInfoStates && testingInfoStates.currentProductType !== 202) {
  //         // For non-Equipment products, always show 530 and hide 619
  //         testData = testData.filter(data => data.id !== 619);
  //       }
  //       testData.sort(this.sortDynamic('label'));
  //       testData = this.modifyData(testData);
  //   }
    
  //   const preservedArray = [...currentArray];
    
  //   // Add manually selected tests to their correct indices
  //   // IMPORTANT: Expand array if needed to accommodate manual selections
  //   // BUT skip PFAS tests that should NOT be selected based on repellent/foodOrMouth state
  //   // AND skip tests that were explicitly deleted by the user (not in current form state)
  //   manualSelections.forEach(testId => {
  //     const isBrominated = testId === 516 || testId === 622;
  //     // Skip if this test was explicitly deleted by the user
  //     // (not present in the current form state means user removed it)
  //     if (!isBrominated && !currentFormTestPackageIds.has(testId) && !currentArray.includes(testId)) {
  //       return; // Skip - test was manually deleted
  //     }
      
  //     // For AP/FW/EQ/Accessories products, check PFAS test conditions
  //     if (testType === 'testPackages' && [200, 201, 202, 206].includes(productId)) {
  //       // Don't restore test 597 if both repellent and foodOrMouth are 'No'
  //       if (testId === 597 && testingInfoStates.repellent !== 'Yes' && testingInfoStates.foodOrMouth !== 'Yes') {
  //         return; // Skip this test
  //       }
  //       // Don't restore test 607 if repellent is 'No'
  //       if (testId === 607 && testingInfoStates.repellent !== 'Yes') {
  //         return; // Skip this test
  //       }
  //     }
      
  //     // For packaging tests
  //     if (testType === 'testPackagesPackaging' && [200, 201, 202, 206].includes(productId)) {
  //       // Don't restore test 586 if both repellent and foodOrMouth are 'No'
  //       if (testId === 586 && testingInfoStates.repellent !== 'Yes' && testingInfoStates.foodOrMouth !== 'Yes') {
  //         return; // Skip this test
  //       }
  //       // Don't restore test 608 if repellent is 'No'
  //       if (testId === 608 && testingInfoStates.repellent !== 'Yes') {
  //         return; // Skip this test
  //       }
  //     }
      
  //     const testIndex = testData.findIndex(test => test.id === testId);
  //     if (testIndex !== -1) {
  //       // Expand array to include this index if necessary
  //       while (preservedArray.length <= testIndex) {
  //         preservedArray.push(null);
  //       }
  //       preservedArray[testIndex] = testId;
  //     }
  //   });
    
  //   return preservedArray;
  // };

  // Get test packages for a specific material type
  // getTestPackagesForMaterialType = (removedId) => {
  //   const { testingInfoStates } = this.props;
    
  //   // Find the TP1 object in the array
  //   const tp1Obj = Array.isArray(testPackageMatrixMapping)
  //     ? testPackageMatrixMapping.find(obj => obj.TP1)
  //     : undefined;
  //   // Get materialType array from TP1
  //   const tp1MaterialTypes = tp1Obj && tp1Obj.TP1 && tp1Obj.TP1.materialType
  //     ? tp1Obj.TP1.materialType
  //     : [];
  //   let tp2MaterialTypes = [];
  //   if (testingInfoStates.enableTP2 === true) {
  //     const tp2Obj = Array.isArray(testPackageMatrixMapping)
  //       ? testPackageMatrixMapping.find(obj => obj.TP2)
  //       : undefined;
  //     // Get materialType array from TP2
  //     tp2MaterialTypes = tp2Obj && tp2Obj.TP2 && tp2Obj.TP2.materialType
  //       ? tp2Obj.TP2.materialType
  //       : [];
  //   }

  //   let testPackageIds = [];
    
  //   // Check TP1 mappings
  //   const match = tp1MaterialTypes.find(item => item.id === removedId);
  //   if (match && Array.isArray(match.testPackage)) {
  //     testPackageIds = testPackageIds.concat(match.testPackage);
  //   }
    
  //   // Check TP2 mappings
  //   const match2 = tp2MaterialTypes.find(item => item.id === removedId);
  //   if (match2 && Array.isArray(match2.testPackage)) {
  //     testPackageIds = testPackageIds.concat(match2.testPackage);
  //   }
  //   return testPackageIds;
  // };

  // Get test packages for selected material types and auto-select them
  // getTP1TestPackageIdsForMaterialTypes = (selectedMaterialTypes) => {
  //   const { testingInfoStates } = this.props;
  //   // Find the TP1 object in the array
  //   const tp1Obj = Array.isArray(testPackageMatrixMapping)
  //     ? testPackageMatrixMapping.find(obj => obj.TP1)
  //     : undefined;
  //   // Get materialType array from TP1
  //   const tp1MaterialTypes = tp1Obj && tp1Obj.TP1 && tp1Obj.TP1.materialType
  //     ? tp1Obj.TP1.materialType
  //     : [];
  //   let tp2MaterialTypes = [];
  //   if (testingInfoStates.enableTP2 === true) {
  //     const tp2Obj = Array.isArray(testPackageMatrixMapping)
  //       ? testPackageMatrixMapping.find(obj => obj.TP2)
  //       : undefined;
  //     // Get materialType array from TP2
  //     tp2MaterialTypes = tp2Obj && tp2Obj.TP2 && tp2Obj.TP2.materialType
  //       ? tp2Obj.TP2.materialType
  //       : [];
  //   }

  //   let testPackageIds = [];
  //   selectedMaterialTypes.forEach(materialId => {
  //     const match = tp1MaterialTypes.find(item => item.id === materialId);
  //     if (match && Array.isArray(match.testPackage)) {
  //       testPackageIds = testPackageIds.concat(match.testPackage);
  //     }
  //   });
  //   selectedMaterialTypes.forEach(materialId => {
  //     const match = tp2MaterialTypes.find(item => item.id === materialId);
  //     if (match && Array.isArray(match.testPackage)) {
  //       testPackageIds = testPackageIds.concat(match.testPackage);
  //     }
  //   });
  //   const testPackageIdsArray = Array.isArray(testPackageIds)
  //     ? testPackageIds.filter(id => id != null).map(id => typeof id === 'object' ? id.id : id)
  //     : [];
  //   const testPackageIdsForSelectionNormalized = testPackageIdsArray.map(id => Number(id));
    
  //   // Get processed jewelry array
  //   const jewelry = individualTest[0].jewelry.filter(data => data.isTestAvailable === true);
  //   jewelry.sort(this.sortDynamic('label'));
  //   // Use our new helper function to select all test packages (handles variants automatically)
  //   if (testPackageIdsForSelectionNormalized.length > 0) {
  //     // Use the new helper function to select multiple test packages with batch updates
  //     const result = this.selectMultipleTestPackages(
  //       testPackageIdsForSelectionNormalized, 
  //       { debug: true }
  //     );
  //     return result;
  //   }
    
  //   // Return empty arrays if no test packages to select
  //   return {
  //     testPackages: new Array(this.getProcessedArraysAndIndices().common.length).fill(null),
  //     testPackagesPackaging: new Array(this.getProcessedArraysAndIndices().packaging.length).fill(null),
  //     testPackagesJewelry: new Array(individualTest[0].jewelry.filter(data => data.isTestAvailable === true).length).fill(null),
  //     variantUpdates: {}
  //   };
  // };

  // Returns true when testPackageId (583 or 536) is auto-selected by the Natural Materials logic,
  // meaning the user should not be able to toggle it manually.
  isNaturalMaterialAutoSelected = (testPackageId) => {
    // const { testingInfoStates, getRecycledContentValue } = this.props;
    // const selectedMaterialTypes = this.getSelectedMaterialsAndVariants();
    // const is6020 = selectedMaterialTypes.includes(6020); // receipt paper
    // const is6021 = selectedMaterialTypes.includes(6021); // non-receipt paper
    // const isRecycleYes = testingInfoStates.recycle === 'Yes' || getRecycledContentValue === 'Yes';

    // if (testPackageId === 583) {
    //   // Bisphenols auto-selected for receipt paper always, or non-receipt paper + recycled
    //   return is6020 || (is6021 && isRecycleYes);
    // }
    // if (testPackageId === 536) {
    //   // Total Heavy Metals auto-selected only when natural material + recycled + TP2 enabled
    //   return (is6020 || is6021) && isRecycleYes && testingInfoStates.enableTP2 === true;
    // }
    return false;
  }

  render() {
    const { sucessFill, testingInfoStates, isPartialEdit, productId, getScreeningInkVarient, getInitialCertificationArry, getRecycledContentValue, change } = this.props;
    const { submitModal, message, electronicClearbtn, jewelryClearbtn, enableTP2Message } = this.state;
    const packagingTests = MaterialTypes.filter(data => data.category === "packaging-test" && data.isTestAvailable === true);
    const packagingTestIds = packagingTests.map(data => data.id)
      const packagingTestVariantIds = packagingTests.map(data => data.variant ? data.variants.map(data => data.id) : null)
      packagingTestVariantIds.push(packagingTestIds)
      var common = individualTest[0].common.filter(data => data.isTestAvailable === true);
    if (testingInfoStates && (testingInfoStates.currentProductType === 202 || productId === 202)) {
          if (testingInfoStates.eyeWear === 'Yes') {
            // Show 619 (Phthalates Eyewear), hide 530 (regular Phthalates)
            common = common.filter(data => data.id !== 530);
          } else {
            // Show 530 (regular Phthalates), hide 619 (Phthalates Eyewear)
            common = common.filter(data => data.id !== 619);
          }
    } else if (testingInfoStates && (testingInfoStates.currentProductType !== 202 && productId !== 202)) {
            // For non-Equipment products, always show 530 and hide 619
            common = common.filter(data => data.id !== 619);
      }
      common.sort(this.sortDynamic('label'));
    common = this.modifyData(common);
    var toys = individualTest[0].toys.filter(data => data.isTestAvailable === true);
    toys.sort(this.sortDynamic('label'));
    toys = this.modifyData(toys);
    var packaging = individualTest[0].packaging.filter(data => data.isTestAvailable === true);
    packaging.sort(this.sortDynamic('label'));
    packaging = this.modifyData(packaging);
    var jewelry = individualTest[0].jewelry.filter(data => data.isTestAvailable === true);
    jewelry.sort(this.sortDynamic('label'));
    jewelry = this.modifyData(jewelry);
    var electronic = individualTest[0].electronic.sort(this.sortDynamic('label'));
    electronic = this.modifyData(electronic);
    var rslTests = MaterialTypes.filter(data => data.category === "rsl-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    rslTests = this.modifyData(rslTests);
    var otherTest = MaterialTypes.filter(data => data.category === "other-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    otherTest = this.modifyData(otherTest);
    var packagingTestSort = packagingTests.sort(this.sortDynamic('label'));
    packagingTestSort = this.modifyData(packagingTestSort);
    var jewelryTest = MaterialTypes.filter(data => data.category === "jewelry-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    var electronicTest = MaterialTypes.filter(data => data.category === "electronic-test" && data.isTestAvailable === true).sort(this.sortDynamic('label'));
    electronicTest = this.modifyData(electronicTest);
    const materialTypesSorted = rslTests.concat(otherTest).concat(packagingTestSort).concat(jewelryTest).concat(electronicTest);
    return (
      <>
        <form className="form">
          <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
            Sample Type, Age Group, Sample Color, Season, Year, Testing Type Fields, Sample Description are Mandatory
            <span className="astericks ml-pos1">&#42;</span>
          </H4>
          <div className="p2-sm">
            <H4 className="text-color-accent u-bold page-title-has-back sub-heading">MATERIAL INFORMATION</H4>
          </div>
          <div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Supplier Name</H5>
              <Field component={TextInput} name="supplierName" type="text" disabled />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Location Name</H5>
              <Field component={TextInput} name="supLocName" type="text" disabled />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Material Name</H5>
              <Field component={TextInput} name="testmaterialName" type="text" disabled />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Material Number</H5>
              <Field component={TextInput} name="testmaterialNumber" type="text" disabled />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Material ID</H5>
              <Field component={TextInput} name="refId" type="text" disabled />
            </div>
          </div>
          <div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Sample Type
                <span className="astericks" >&#42;</span></H5>
              <Field
                component={DropDown}
                name="sampleType"
                placeholder="Select Sample Type"
                options={getSampleTypeInfo()}
                className="dropdown-border-location"
              />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Sample Color<span className="astericks" >&#42;</span></H5>
              <Field
                component={DropDown}
                name="sampleColor"
                placeholder="Select Sample Color"
                options={getSampleColor()}
                className="dropdown-border-location"
              />
            </div>
          </div>
          <div className="mb3-sm mt2-sm">
            <div className="p2-sm ncss-col-sm-12">
              <H5 className="u-bold">Color Information</H5>
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Color Code</H5>
              <Field component={TextInput} name="colorCode" type="text" />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Color Group Name</H5>
              <Field component={TextInput} name="colorName" type="text" />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Colorway (only for finished product)</H5>
              <Field component={TextInput} name="colorway" type="text" />
            </div>
            <div className="ncss-col-sm-4 ncss-input-container ">
              <H5 className="u-bold description p2-top-sm p2-bottom-sm">Age Group<span className="astericks" >&#42;</span></H5>
              <Field
                component={DropDown}
                name="ageGroup"
                placeholder="Select Age Group"
                options={getAgeGroup()}
                className="dropdown-border-location"
              />
            </div>
          </div>
          <div className="p2-sm">
            <H4 className="ncss-label ncss-label pr3-sm u-bold desc-h4">Sample Description
              <span className="astericks" >&#42;</span></H4>
            <Field
              component={TextInput}
              name="sampleDescription"
              type="textarea"
              className="ncss-col-sm-12 description u-bold trf-data-text"
            />
          </div>
          <div className="pt2-sm pb2-sm">
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Does material have repellent finish?<span className="astericks ml-pos1">&#42;</span>
            </div>
            <div className="ncss-col-sm-7 ncss-radio-container" onChange={this.testPackageForPFAS.bind(this)}>
              {repellent.map(data => (
                <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text">
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="repellent"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="pt2-sm pb2-sm">
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Is the material intended to come into contact with food or mouth?  <span className="astericks ml-neg3">&#42;</span>
            </div>
            <div className="ncss-col-sm-7 ncss-radio-container" onChange={this.testPackageForPFAS.bind(this)}>
              {foodOrMouth.map(data => (
                <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text">
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="foodOrMouth"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className={productId === 202 ? "pt2-sm pb2-sm div-block" : "pt2-sm pb2-sm div-none"}>
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Is this material intended for eye-wear frames? <span className="astericks ml-neg3">&#42;</span>
            </div>
            <div className="ncss-col-sm-7 ncss-radio-container">
              {eyeWear.map(data => (
                <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text">
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="eyeWear"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className={productId === 202 ? "pt2-sm pb2-sm div-block" : "pt2-sm pb2-sm div-none"}>
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Is this material intended for Play/Baby/Yoga mat? <span className="astericks ml-neg3">&#42;</span>
            </div>
            <div className="ncss-col-sm-7 ncss-radio-container">
              {mates.map(data => (
                <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text">
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="mates"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="pt2-sm pb2-sm">
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Does this material sample contain recycled content?  <span className="astericks ml-neg3">&#42;</span>
            </div>
            <div className="ncss-col-sm-7 ncss-radio-container">
              {recycledContent.map(data => (
                <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text" onChange={this.recycledContentHandleChange.bind(this)}>
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="recycle"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                </div>
              ))}
            </div>
          </div>
          {getRecycledContentValue === 'Yes' || testingInfoStates.recycle === 'Yes' ?
            (<Fragment><div className="pt2-sm pb2-sm">
              <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
                List the samples recycled material source (e.g. post industrial, post consumer, pre consumer, etc.)  <span className="astericks ml-neg3">&#42;</span>
              </div>
              <div className="ncss-col-sm-4 ncss-input-container">
                <Field component={TextInput} name="listRecycle" type="text" />
              </div>
            </div>
              <div className="pt2-sm pb2-sm">
                <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
                  Describe the recycled content in the material sample (e.g. 20% recycled PET, 10% recycled TPU, etc.) <span className="astericks ml-neg3">&#42;</span>
                </div>
                <div className="ncss-col-sm-4 ncss-input-container">
                  <Field component={TextInput} name="describeRecycle" type="text" />
                </div>
              </div></Fragment>) : ""}

          <div className="mb3-sm mt2-sm">
            <div className="p2-sm ncss-col-sm-12"><H5 className="u-bold">Certificate</H5></div>
            {getInitialCertificationArry.length > 0 ? this.certificationAddMore() : ''}
          </div>
          <div className="p2-sm">
            <H4 className="text-color-accent u-bold page-title-has-back sub-heading">SEASON</H4>
          </div>
          <div className="mb3-sm mt2-sm">
            <div className=" ncss-col-sm-7 inline-flex-display p2-sm u-bold ">
              <div className="ncss-col-sm-2 description u-bold flex-head-center trf-data-text">
                Season <span className="astericks ml-neg4">&#42;</span>
              </div>
              <div className="ncss-col-sm-8  ncss-radio-container">
                {Season.map(data => (
                  <div key={data.label} className="ncss-col-sm-3 ncss-radio-container">
                    <Field
                      type="radio"
                      component={Radiobutton}
                      name="season"
                      value={data.id}
                      label={data.label}
                      checked={false}
                      id={data.id}
                      isIcon={false}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mb3-sm mt2-sm">
            <div className=" ncss-col-sm-7 inline-flex-display p2-sm u-bold ">
              <div className="ncss-col-sm-2 description u-bold trf-data-text">
                Year
                <span className="astericks">&#42;</span>
              </div>
              <div className="ncss-col-sm-12 grid-align-fix ncss-input-container">
                <div className="ncss-col-sm-12">
                  <Field component={YearSelector} name="Year" minDate={new Date().getTime()} />
                </div>
              </div>
            </div>
          </div>
          <div className="p2-sm">
            <H4 className="text-color-accent u-bold page-title-has-back sub-heading">TESTING INFORMATION</H4>
            <H5 className="u-bold description">Description for Testing Information</H5>
          </div>
          <div className="mb3-sm mt2-sm">
            <div className="p2-sm ncss-col-sm-4">
              <H5 className="u-bold description">
                Testing Type <span className="astericks ml-neg3">&#42;</span>
              </H5>

              <H6 className="sample p2-sm">
                (R&D sample tests cannot be converted to Production-ready material samples after testing.)
              </H6>
            </div>
            <div className="ncss-col-sm-7 ncss-form-group p4-bottom-sm p4-top-sm">
              {SampleInfo.map(data => (
                <div key={data.label} className="ncss-col-sm-6 ncss-radio-container">
                  <Field
                    type="radio"
                    component={Radiobutton}
                    name="testingType"
                    value={data.value}
                    checked={false}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                  />
                  <span className="pl6-sm radio-sub-info">{data.sub}</span>
                </div>
              ))}
            </div>
          </div>
          {(productId === 204) ? (
            <Fragment>
              <div className="pt2-sm pb2-sm">
                <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
                  Will this electonic material be embedded into a finished product (e.g. Footwear)?  <span className="astericks ml-neg3">&#42;</span>
                </div>
                <div className="ncss-col-sm-7 ncss-radio-container">
                  {embededProduct.map(data => (
                    <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text">
                      <Field
                        type="radio"
                        component={Radiobutton}
                        name="isElectEmbedded"
                        value={data.value}
                        checked={false}
                        label={data.label}
                        id={data.id}
                        isIcon={false}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="pt2-sm pb2-sm">
                <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
                  Is this electronic material intended to come in contact with user's skin?
                  <span className="astericks ml-neg3">&#42;</span>
                </div>
                <div className="ncss-col-sm-7 ncss-radio-container">
                  {skinContact.map(data => (
                    <div key={data.label} className="ncss-col-sm-6 u-bold trf-data-text"
                      onChange={this.skinContactHandleChange.bind(this)}>
                      <Field
                        type="radio"
                        component={Radiobutton}
                        name="skinContact"
                        value={data.value}
                        checked={false}
                        label={data.label}
                        id={data.id}
                        isIcon={false}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Fragment>
          ) : ''}
          <div className="pt2-sm pb2-sm">
            <div className="ncss-col-sm-4 description p2-bottom-sm trf-data-text">
              Enable TP2 {testingInfoStates.enableTP2}
            </div>
            <div className="ncss-col-sm-1 ncss-radio-container ml-7p">
              <ToggleSwitch
                id="enableTP2"
                name="enableTP2"
                checked={testingInfoStates.enableTP2}
                onChange={this.onToggleSwitchChange}
              />
            </div>
            <div className="ncss-col-sm-6 description p2-top-sm trf-data-text">
              <div className='enable-tp2-error-msg'>{enableTP2Message}</div>
            </div>
          </div>
          <div className="p2-sm">
            {testingInfoStates && testingInfoStates.testingType === 'PR' && !isNaN(productId) ? (
              <H4 className={sucessFill ? 'error-text pb3-sm' : 'error-hide'}>
                Material Type selection is mandatory for Testing Type - Production Ready
                <span className="astericks">&#42;</span>
              </H4>
            ) : null}
            {testingInfoStates && testingInfoStates.testingType === 'RD' && !isNaN(productId) ? (
              <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
                Either Material Type selection Or Individual Test selection is mandatory for Testing Type - Research &amp; Development(R&amp;D)
                <span className="astericks">&#42;</span>
              </H4>
            ) : null}
            {testingInfoStates && (testingInfoStates.testingType === 'PR' || testingInfoStates.testingType === 'RD') && testingInfoStates.currentProductType
              === null ? (
              <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
                Product Type is Mandatory in Step 1
                <span className="astericks">&#42;</span>
              </H4>
            ) : null}
            <H5 className="u-bold ">
              <div className="ncss-col-sm-10 header-text-mat">
                SELECT MATERIAL TYPE<span className="astericks material-type">&#42;</span>
              </div>
              <div className="ncss-col-sm-2">
                {!isPartialEdit ?
                  <IconButton
                    className="clear-button"
                    icon="trash-alt icon-button-margin"
                    onClick={this.resetTestingType}
                    title="Clear Material Selection"
                  />
                  :
                  null
                }
              </div>
            </H5>
            <H6 className="sample">
              Select Test Package (If sample is production-ready material, you must select a Test Package.)
            </H6>
          </div>

          <div className={"ncss-col-sm-12 mb1-sm material-type-section"}>
            {(productId !== 203 && productId !== 205) ? (<div className='mat-data-text mb1-sm'>PRODUCT RSL TESTS (AP, FW & EQ)</div>) : ''}
            {materialTypesSorted.map((materialData, index) => (
              materialData.isTestAvailable !== false ?
                (<span key={materialData.label}>
                  {materialData.id === 417 ? <br /> : null}
                  {materialData.id === 6010 && (productId === 203 || productId === 206) ?
                    <span>
                      <div className="ncss-col-sm-12 pl0-sm pr0-sm mb1-sm top-border"><div className='mat-data-text'>PACKAGING RSL TESTS</div></div>
                    </span>
                    : materialData.id === 4150 && materialData.category === "electronic-test" && (productId === 204 || productId === 206) ?
                      <span>
                        <div className="ncss-col-sm-12 pl0-sm pr0-sm mb1-sm top-border">
                          <div className='mat-data-text'>ELECTRONIC RSL TESTS </div></div>
                      </span>
                      : materialData.category === "jewelry-test" && index === 22
                        && (productId === 205 || productId === 206) ?
                        <span>
                          <div className="ncss-col-sm-12 pl0-sm pr0-sm mb1-sm top-border"><div className='mat-data-text'>JEWELRY RSL TESTS</div></div>
                        </span>
                        : null}
                  {/* RSL TESTS Container start here */}
                  {materialData.id !== 4143 && materialData.id !== 4142 &&
                    ((productId === 200 || productId === 201 || productId === 202 || productId === 204 || productId === 206 || isNaN(productId))
                      && materialData.category === 'rsl-test') ?
                    (<div key={materialData.label} className={`ncss-col-sm-4 u-bold pb1-sm`} >
                      <span className="ncss-checkbox-container">
                        <Field
                          type="checkbox"
                          component={Checkbox}
                          name={`materialType[${index}]`}
                          value={materialData.id}
                          normalize={normalizeBoolean(materialData.id)}
                          label={materialData.label}
                          variant={materialData.variant}
                          variants={materialData.variants}
                          id={materialData.id}
                          mandatory={materialData.mandatory}
                          isIcon={false}
                          disabled={isNaN(productId) ? true : false}
                        />
                      </span>
                      {testingInfoStates.materialType && (materialData.variant !== false)
                        ? testingInfoStates.materialType
                          .filter(element => element != null)
                          .map(id =>
                            id === materialData.id && (materialData.isTestAvailable !== false) && find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variant ? (
                              (id === 400 || id === 415) ?
                                <PopOver>
                                  <span>
                                    <H4 className={sucessFill && id !== 415 ? 'error-text' : 'error-hide'}>
                                      Select one (mandatory)<span className="astericks">&#42;</span>
                                    </H4>
                                    {find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants.sort(this.sortDynamic('label')).map((variant, varientIndex) => (
                                      <div key={materialData.label} className=" ncss-checkbox-container">
                                        <Field
                                          type="checkbox"
                                          component={Checkbox}
                                          name={`variants${id}[${varientIndex}]`}
                                          normalize={normalizeBoolean(variant.id)}
                                          label={variant.label}
                                          value={variant.id}
                                          id={variant.id}
                                          isIcon={false}
                                        />
                                      </div>
                                    ))}
                                  </span>
                                </PopOver>
                                :
                                <span>
                                  <PopOver>
                                    <span>
                                      <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
                                        Select one (mandatory)<span className="astericks">&#42;</span>
                                      </H4>
                                      {find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants.map(variant => (
                                        <Fragment>
                                          <div key={materialData.label} className=" ncss-radio-container" onChange={this.handleChange.bind(this)}>
                                            <Field
                                              type="radio"
                                              component={Radiobutton}
                                              name={`variants${materialData.id}`}
                                              label={variant.label}
                                              value={variant.id}
                                              id={variant.id}
                                                disabled={id === 6017 && variant.id === 6022 && testingInfoStates.enableTP2 !== true}
                                              isIcon={false} />
                                          </div>
                                          <div className={(getScreeningInkVarient === 4052 &&
                                            getScreeningInkVarient !== 0) || (getScreeningInkVarient === 4052 && testingInfoStates.testingInfoStatus === 'Edit'
                                            ) ? 'div-block sub-variant-div' : 'div-none sub-variant-div'}>
                                            {variant.subVariant === true ? (
                                              variant.subVariants.map(subvariant => (
                                                <div key={materialData.label} className="ncss-radio-container">
                                                  <Field
                                                    type="radio"
                                                    component={Radiobutton}
                                                    name={`subVariants`}
                                                    label={subvariant.label}
                                                    value={subvariant.id}
                                                    id={subvariant.id}
                                                    isIcon={false}
                                                  />
                                                </div>
                                              )))
                                              : ''}</div>
                                        </Fragment>
                                      ))}
                                    </span>
                                  </PopOver>
                                </span>
                            ) : null
                          )
                        : null}
                    </div>) : ''
                  }
                  {/*
                {/* RSL TESTS Container end here */}
                  {/* PACKAGING TESTS Container start here */}
                  {materialData.id !== 4143 && materialData.id !== 4142 &&
                    ((productId === 203 || productId === 206) && materialData.category === 'packaging-test') ?
                    (<div key={materialData.label} className={`ncss-col-sm-4 u-bold pb1-sm`}>
                      <span className="ncss-checkbox-container">
                        <Field
                          type="checkbox"
                          component={Checkbox}
                          name={`materialType[${index}]`}
                          value={materialData.id}
                          normalize={normalizeBoolean(materialData.id)}
                          label={materialData.label}
                          variant={materialData.variant}
                          variants={materialData.variants}
                          id={materialData.id}
                          mandatory={materialData.mandatory}
                          isIcon={false}
                        />
                      </span>
                      {testingInfoStates.materialType && (materialData.variant !== false)
                        ? testingInfoStates.materialType
                          .filter(element => element != null)
                          .map(id =>
                            id === materialData.id && (materialData.isTestAvailable !== false) && find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variant ? (
                              (id === 400 || id === 415) ?
                                <PopOver>
                                  <span>
                                    <H4 className={sucessFill && id !== 415 ? 'error-text' : 'error-hide'}>
                                      Select one (mandatory)<span className="astericks">&#42;</span>
                                    </H4>
                                    {find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants.sort(this.sortDynamic('label')).map((variant, varientIndex) => (
                                      <div key={materialData.label} className=" ncss-checkbox-container">
                                        <Field
                                          type="checkbox"
                                          component={Checkbox}
                                          name={`variants${id}[${varientIndex}]`}
                                          normalize={normalizeBoolean(variant.id)}
                                          label={variant.label}
                                          value={variant.id}
                                          id={variant.id}
                                          isIcon={false}
                                        />
                                      </div>
                                    ))}
                                  </span>
                                </PopOver>
                                :
                                <span>
                                  <PopOver>
                                    <span>
                                      <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
                                        Select one (mandatory)<span className="astericks">&#42;</span>
                                      </H4>
                                      {find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants.map(variant => (
                                        <Fragment>
                                          <div key={materialData.label} className=" ncss-radio-container" onChange={this.handleChange.bind(this)}>
                                            <Field
                                              type="radio"
                                              component={Radiobutton}
                                              name={`variants${materialData.id}`}
                                              label={variant.label}
                                              value={variant.id}
                                              id={variant.id}
                                              disabled={id === 6017 && variant.id === 6022 && testingInfoStates.enableTP2 !== true}
                                              isIcon={false} />
                                          </div>
                                          <div className={(getScreeningInkVarient === 4052 &&
                                            getScreeningInkVarient !== 0) || (getScreeningInkVarient === 4052 && testingInfoStates.testingInfoStatus === 'Edit'
                                            ) ? 'div-block sub-variant-div' : 'div-none sub-variant-div'}>
                                            {variant.subVariant === true ? (
                                              variant.subVariants.map(subvariant => (
                                                <div key={materialData.label} className="ncss-radio-container">
                                                  <Field
                                                    type="radio"
                                                    component={Radiobutton}
                                                    name={`subVariants`}
                                                    label={subvariant.label}
                                                    value={subvariant.id}
                                                    id={subvariant.id}
                                                    isIcon={false}
                                                  />
                                                </div>
                                              )))
                                              : ''}</div>
                                        </Fragment>
                                      ))}
                                    </span>
                                  </PopOver>
                                </span>
                            ) : null
                          )
                        : null}
                    </div>) : ''
                  }
                  {/* PACKAGING TESTS Container end here */}
                  {/* ELECTRONIC TESTS Container end here */}
                  {
                    ((materialData.category === "electronic-test" && materialData.id !== 4143 && materialData.id !== 6021 && materialData.id !== 4144 && materialData.id !== 6023) && (productId === 204 || productId === 206)) ? (
                      <Fragment>
                        <div key={materialData.label} className="ncss-col-sm-4 u-bold pb1-sm " >
                          <span className="ncss-radio-container">
                            <Field
                              type="radio"
                              component={Radiobutton}
                              name={`materialType[${index}]`}
                              value={materialData.id}
                              normalize={normalizeBoolean(materialData.id)}
                              label={materialData.label}
                              variant={materialData.variant}
                              variants={materialData.variants}
                              id={materialData.id}
                              onChange={() => this.electCategoryHandleChange(materialData.id)}
                              isIcon={false}
                            />
                          </span>
                        </div>
                        {materialData.id === 4152 &&
                          (<Button className="download-print-button-FRF u-bold pb1-sm text-color-accent" disabled={electronicClearbtn}
                            onClick={this.clearElectronicRadioButtons} title='Clear the Radio buttons' style={{
                              fontSize: 'initial', marginLeft: '30px'
                            }}>clear</Button>)}
                      </Fragment>
                    ) : ''
                  }
                  {/* ELECTRONIC TESTS Container end here */}
                  {/* JEWELRY TESTS Container start here */}
                  {
                    materialData.category === "jewelry-test" && (index >= 22 && index <= 25)
                      && (productId === 205 || productId === 206) ? (
                      <Fragment>
                        <div key={materialData.label} className="ncss-col-sm-4 u-bold pb1-sm ">
                          <span className="ncss-radio-container">
                            <Field
                              type="radio"
                              component={Radiobutton}
                              name={`materialType[${index}]`}
                              value={materialData.id}
                              normalize={normalizeBoolean(materialData.id)}
                              label={materialData.label}
                              variant={materialData.variant}
                              variants={materialData.variants}
                              id={materialData.id}
                              isIcon={false}
                              onChange={() => this.jewelryHandleChange(materialData.id)}
                            />
                          </span>
                          {testingInfoStates.materialType && (materialData.variants !== false)
                            ? testingInfoStates.materialType
                              .filter(element => element != null)
                              .map(id =>
                                id === materialData.id && (materialData.isTestAvailable !== false) && find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants ? (
                                  <span>
                                    <PopOver>
                                      <span>
                                        <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
                                          Select one (mandatory)<span className="astericks">&#42;</span>
                                        </H4>
                                        {find(materialTypesSorted, ['id', testingInfoStates.materialType[index]]).variants.map(variant => (
                                          <Fragment>
                                            <div key={materialData.label} className=" ncss-radio-container" onChange={this.handleChange.bind(this)}>
                                              <Field
                                                type="radio"
                                                component={Radiobutton}
                                                name={`variants${materialData.id}`}
                                                label={variant.label}
                                                value={variant.id}
                                                id={variant.id}
                                                disabled={id === 6017 && variant.id === 6022 && testingInfoStates.enableTP2 !== true}
                                                isIcon={false} />
                                            </div>

                                          </Fragment>
                                        ))}
                                      </span>
                                    </PopOver>
                                  </span>
                                ) : null
                              )
                            : null}
                        </div>
                        {materialData.category === "jewelry-test" && (index === 25)
                          && (
                            <div className="ncss-col-sm-4 u-bold pb1-sm ">
                              <Button className="download-print-button-FRF ncss-col-sm-4 u-bold pb1-sm " disabled={jewelryClearbtn}
                                onClick={this.clearJewelryRadioButtons} class="u-bold pb1-sm text-color-accent" title='Clear the Radio buttons' style={{
                                  fontSize: 'initial', marginLeft: '-49px'
                                }}>clear</Button></div>
                          )}
                      </Fragment>
                    ) : ''
                  }
                </span>) : ''
            ))}
          </div>
          {testingInfoStates && testingInfoStates.materialType &&
            (
              (testingInfoStates.materialType.includes(418)) ||
              (testingInfoStates.materialType.includes(405)) ||
              (testingInfoStates.materialType.includes(408))) ? (
            <div className="pt2-sm pb2-sm">
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">Ink System Name</H5>
                <Field component={TextInput} name="inkSystemName" type="text"
                />
              </div>
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">Base Name</H5>
                <Field component={TextInput} name="baseName" type="text" />
              </div>
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">
                  Pigment Color<span className="astericks ml-pos">&#42;</span>
                </H5>
                <Field component={TextInput} name="pigmentColor" type="text" />
              </div>
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">Additive 1 Name</H5>
                <Field component={TextInput} name="additive1Name" type="text" />
              </div>
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">Additive 2 Name</H5>
                <Field component={TextInput} name="additive2Name" type="text" />
              </div>
              <div className="ncss-col-sm-4 ncss-input-container ">
                <H5 className="u-bold description p2-top-sm p2-bottom-sm">Additive 3 Name</H5>
                <Field component={TextInput} name="additive3Name" type="text" />
              </div>{' '}
            </div>
          ) : null}
          <div className={"collapsible_IndividualTest_container"}>
            <Collapsible
              trigger={
                <div className="ncss-col-sm-12 collapse-p0 ">
                  <H5 className="ncss-col-sm-11 collapse-p0 u-bold testpackage-font-adjust">
                    Select Individual Test
                  </H5>
                  <div className="ncss-col-sm-1 collapse-p0">
                    <i className="fas fa-caret-down fa-pull-right" />
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className="ncss-col-sm-12 collapse-p0">
                  <div className="ncss-col-sm-11 collapse-p0 testpackage-font-adjust">Select Individual Test</div>
                  <div className="ncss-col-sm-1 collapse-p0">
                    <i className="fas fa-caret-up fa-pull-right" />
                  </div>
                </div>
              }
              triggerStyle={titleStyles}
              triggerClassName="collapsible mt3-sm"
            >
              <div className="p2-sm">
                <H6 className="sample">
                  Please select a Test Package in the box above. You can then select the Individual Tests you want below.
                  If this sample is for Research & Development (R&D), then it does not affect annual testing requirements
                  for Production-ready material.
                </H6>
              </div>
              {/* Individual Test Packages Container start here */}
              <div className="ncss-col-sm-12  ncss-checkbox-container ">
                <div className={productId !== 203 && productId !== 205 ? 'div-block' : 'div-none'}>
                  {common.map((data, index) => (
                    data.isTestAvailable !== false ?
                      <div key={data.label} className="ncss-col-sm-4  description u-bold trf-data-text pb1-sm">
                        <span className="ncss-checkbox-container">
                          <Field
                            type="checkbox"
                            component={Checkbox}
                            normalize={normalizeBoolean(data.id)}
                            name={`testPackages[${index}]`}
                            label={data.label}
                            checked={testingInfoStates.testPackages && (testingInfoStates.testPackages[index] === data.id || testingInfoStates.testPackages.includes(data.id))}
                            disabled={
                              (this.isYogaMateSolventRequired() && data.id === 599) ? true :
                              // HIGHEST PRIORITY: Disable PFAS test 597 if repellent or foodOrMouth is 'Yes' (for AP/FW/EQ/Accessories)
                              ((testingInfoStates.repellent === 'Yes' || testingInfoStates.foodOrMouth === 'Yes') && data.id === 597 && [200, 201, 202, 206].includes(productId)) ? true :
                              // HIGHEST PRIORITY: Disable PFAS test 607 if repellent is 'Yes' (for AP/FW/EQ/Accessories)
                              (testingInfoStates.repellent === 'Yes' && data.id === 607 && [200, 201, 202, 206].includes(productId)) ? true :
                              // Allow editing if manually selected (not API-loaded)
                             // this.isCheckboxEnabled(data.id, 'testPackages') ? false :
                              (productId === 203 && (isPartialEdit === false || isPartialEdit === true)) ? true :
                              isNaN(productId) ? true :
                                (productId !== 203 && (isPartialEdit === false || isPartialEdit === true)) ? false : true}
                            isIcon={false}
                            onChange={() => {
                              if (data.variant && testingInfoStates.testPackages && (testingInfoStates.testPackages[index] === data.id || testingInfoStates.testPackages.includes(data.id))) {
                                change(`tp-variants${data.id}`, null);
                              }
                            }}
                          />
                        </span>
                        {data.variant === true && data.variants && data.variants.length > 0 &&
                          testingInfoStates.testPackages &&
                          (testingInfoStates.testPackages[index] === data.id || testingInfoStates.testPackages.includes(data.id)) && (
                          <div className="pl2-sm pt1-sm">
                            {data.variants.map(variant => (
                              <div key={variant.id} className="ncss-radio-container">
                                <Field
                                  type="radio"
                                  component={Radiobutton}
                                  name={`tp-variants${data.id}`}
                                  label={variant.label}
                                  value={variant.id}
                                  id={variant.id}
                                  isIcon={false}
                                  disabled={isNaN(productId) ? true : (productId !== 203 && (isPartialEdit === false || isPartialEdit === true)) ? false : true}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      : null
                  ))}</div>
                <div className={productId === 204 || productId === 206 ? 'div-block' : 'div-none'}>
                  <div className="astericks u-bold ncss-col-sm-12">Electronic</div>
                  {electronic.map((data, index) => (
                    data.isTestAvailable !== false ?
                      <div
                        key={data.label}
                        className="ncss-col-sm-4 ncss-checkbox-container description u-bold trf-data-text"
                      >
                        <Field
                          type="checkbox"
                          component={Checkbox}
                          normalize={normalizeBoolean(data.id)}
                          name={`testPackagesElectronic[${index}]`}
                          label={data.label}
                          disabled={
                            // Allow editing if manually selected (not API-loaded)
                           // this.isCheckboxEnabled(data.id, 'testPackagesElectronic') ? false :
                            ((productId === 203 || productId === 204 || productId === 206) && testingInfoStates.testingType === 'PR') ? true :
                            (productId === 204 && testingInfoStates.testingType === 'RD') ? false :
                              ((productId !== 203 || productId !== 204 || productId !== 206) && (isPartialEdit === false || isPartialEdit === true)) ? false : true}
                          checked={data.checked}
                          className="p1-sm"
                          isIcon={false}
                        />
                      </div>
                      : null
                  ))}</div>
                <div className={productId === 203 || productId === 206 ? 'div-block' : 'div-none'}>
                  <div className="astericks u-bold ncss-col-sm-12">Packaging</div>
                  {packaging.map((data, index) => (
                    data.isTestAvailable !== false ?
                      <div
                        key={data.label}
                        className="ncss-col-sm-4 ncss-checkbox-container description u-bold trf-data-text"
                      >
                        <Field
                          type="checkbox"
                          component={Checkbox}
                          normalize={normalizeBoolean(data.id)}
                          name={`testPackagesPackaging[${index}]`}
                          label={data.label}
                          disabled={
                            // Lock Brominated (Packaging) when auto-selected by Recycled Content + TP2
                            // (data.id === 622 &&
                            //   (getRecycledContentValue === 'Yes' || testingInfoStates.recycle === 'Yes' || testingInfoStates.recycle === true) &&
                            //   testingInfoStates.enableTP2 === true &&
                            //   Array.isArray(testingInfoStates.materialType) &&
                            //   testingInfoStates.materialType.some(id => id !== null && id !== undefined && id !== '') &&
                            //   testingInfoStates.testPackagesPackaging &&
                            //   testingInfoStates.testPackagesPackaging[index] === data.id) ? true :
                            // Disable if auto-selected by Natural Materials rules (Bisphenols 583 / Heavy Metals 536)
                            this.isNaturalMaterialAutoSelected(data.id) ? true :
                            // Allow editing if manually selected (not API-loaded)
                           // this.isCheckboxEnabled(data.id, 'testPackagesPackaging') ? false :
                            ((testingInfoStates.repellent === 'Yes' && (this.isPFASTestIndex(index, packaging, 586) || this.isPFASTestIndex(index, packaging, 608))) || (this.isPFASTestIndex(index, packaging, 586) && testingInfoStates.foodOrMouth === 'Yes')) ? true : ((productId === 203 || productId === '' || productId === 206) && (isPartialEdit === false || isPartialEdit === true)) ? false :
                            (productId && productId !== 203 && (isPartialEdit === false || isPartialEdit === true)) ? true : false}
                          checked={testingInfoStates.testPackagesPackaging && testingInfoStates.testPackagesPackaging[index] === data.id}
                          isIcon={false}
                        />
                      </div>
                      : null
                  ))}</div>
                <div className={productId === 205 || productId === 206 ? 'div-block' : 'div-none'}>
                  <div className="astericks u-bold ncss-col-sm-12">Jewelry</div>
                  {jewelry.map((data, index) => (
                    data.isTestAvailable !== false ?
                      <div
                        key={data.label}
                        className="ncss-col-sm-4 ncss-checkbox-container description u-bold trf-data-text"
                      >
                        <span>
                          <Field
                            type="checkbox"
                            component={Checkbox}
                            normalize={normalizeBoolean(data.id)}
                            name={`testPackagesJewelry[${index}]`}
                            label={data.label}
                            disabled={
                              // Allow editing if manually selected (not API-loaded)
                             // this.isCheckboxEnabled(data.id, 'testPackagesJewelry') ? false :
                              (productId === 203 && (isPartialEdit === false || isPartialEdit === true)) ? true :
                              (productId !== 203 && (isPartialEdit === false || isPartialEdit === true)) ? false : true}
                            checked={testingInfoStates.testPackagesJewelry && testingInfoStates.testPackagesJewelry[index] === data.id}
                            className="p1-sm"
                            isIcon={false}
                            onChange={() => {
                              if (data.variant && testingInfoStates.testPackagesJewelry && testingInfoStates.testPackagesJewelry[index] === data.id) {
                                change(`tp-variants${data.id}`, null);
                              }
                            }}
                          />
                        </span>
                        {data.variant === true && data.variants && data.variants.length > 0 &&
                          testingInfoStates.testPackagesJewelry &&
                          testingInfoStates.testPackagesJewelry[index] === data.id && (
                          <div className="pl2-sm pt1-sm">
                            {data.variants.map(variant => (
                              <div key={variant.id} className="ncss-radio-container">
                                <Field
                                  type="radio"
                                  component={Radiobutton}
                                  name={`tp-variants${data.id}`}
                                  label={variant.label}
                                  value={variant.id}
                                  id={variant.id}
                                  isIcon={false}
                                  disabled={(productId === 203 && (isPartialEdit === false || isPartialEdit === true)) ? true : (productId !== 203 && (isPartialEdit === false || isPartialEdit === true)) ? false : true}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      : null
                  ))}</div>
              </div>
            </Collapsible>
          </div>
          <ConfirmationBox
            message={message}
            submitModal={submitModal}
            submitValue={null}
            closeModal={this.closeSubmitModal}
            buttonsDisplay={false}
          />
        </form>
      </>
    );
  }
}
TestingInfo.propTypes = {
  sucessFill: PropTypes.bool,
  change: PropTypes.func,
  displaySubmitButtonTrf: PropTypes.func,
  displayClearButtonTrf: PropTypes.func,
  updateMaterialField: PropTypes.object,
  testingInfoStates: PropTypes.object,
  onChangeProductType: PropTypes.object,
  onChangeScreeningInkVarient: PropTypes.object,
  initialCertificationArry: PropTypes.func,
  getRecycledContentValue: propTypes.func,
  returnTp1Tp2Type: PropTypes.object,

};
const mapStateToProps = state => ({
  updateMaterialField: state.trf.updateMaterialField,
  testingInfoStates: getFormValues('testingInfo')(state),
  initialMaterialTypes: get(state, 'trf.trfDataForEdit.materialType', []),
  initialTestPackages: get(state, 'trf.trfDataForEdit', null),
  getProductTypeObj: state.trf.onChangeProductType,
  getScreeningInkVarient: state.trf.onChangeScreeningInkVarient,
  getInitialCertificationArry: state.trf.initialCertificationArry,
  getRecycledContentValue: state.trf.recycledContentValue,
  returnTp1Tp2Type: fetchTp1Tp2Count(state),
});

const mapDispatchToProps = dispatch => ({
  InitialProductTypeStore: data => {
    dispatch(InitialProductTypeStore(data));
  },
  currentProductTypeStore: data => {
    dispatch(currentProductTypeStore(data));
  },
  onChangeProductType: (data) => {
    dispatch(onChangeProductType(data));
  },
  onChangeScreeningInkVarient: (data) => {
    dispatch(onChangeScreeningInkVarient(data));
  },
  getProductIdEdit: data => {
    dispatch(getProductIdEdit(data));
  },
  initialCertificationArry: data => {
    dispatch(initialCertificationArry(data))
  },
  recycledContentValue: data => {
    dispatch(recycledContentValue(data))
  },
  productTypeChangeStatus: data => {
    dispatch(productTypeChangeStatus(data))
  }
});


export default reduxForm({
  form: 'testingInfo',
  initialValues: {
    testingType: 'PR',
    repellent: 'No',
    foodOrMouth: 'No',
    //recycledContent: 'No'
  },
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepValues: true,
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TestingInfo)
);